export const auSchools: string[] = [
  ...new Set([
    'Abbotsleigh, Wahroonga',
    'Aberfeldie Primary School, Essendon',
    'Aberfoyle Park High School, Aberfoyle Park',
    'Aboriginal & Islander Independent Community School, Acacia Ridge',
    'Acacia Hill School, Sadadeen',
    'Academy of Mary Immaculate, Fitzroy',
    'Adaminaby Public School, Adaminaby',
    'Adass Israel School - Glen Eira Road Campus, Elsternwick',
    'Adass Israel School, Elsternwick',
    'Adelaide Botanic High School',
    'Adelaide East Education Centre, Paradise',
    'Adelaide High School, Adelaide',
    'Adelaide International School, Adelaide',
    'Adelaide Secondary School of English, Brompton',
    'Adelaide West Special Education Centre, Taperoo',
    'Advance College of Education Incorporated, Rosebud West',
    'Airds High School, Campbelltown',
    'Aitken College, Greenvale',
    'Ajuga School, Glenfield',
    'Al Amanah College, Liverpool',
    'Al Iman College, Melton South',
    'Al Noori Muslim School, Greenacre',
    'Al Sadiq College Yagoona Campus, Yagoona',
    'Al Sadiq College, Greenacre',
    'Al Siraat College, Epping',
    'Al Zahra College, Arncliffe',
    'Al-Ameen College, Langford',
    'Al-Faisal College',
    'Al-Faisal College - Campbelltown, Minto',
    'Al-Faisal College - Liverpool, Austral',
    'Al-Taqwa College - Olive Branch Annexe, Hoppers Crossing',
    'Al-Taqwa College, Truganina',
    'Alamanda K-9 College, Point Cook',
    'Albany Creek State High School, Albany Creek',
    'Albany Secondary Education Support Centre, Albany',
    'Albany Senior High School, Albany',
    'Albert Park College, Albert Park',
    'Albert Park Flexible Learning Centre, Brisbane',
    'Albert Park Primary School, Albert Park',
    'Albion Park High School, Albion Park',
    'Albury High School, Albury',
    'Alcoota School, Engawala',
    'Aldinga Payinthi College',
    'Aldridge State High School, Maryborough',
    'Alekarenge School, Ali Curung',
    'ALESCO Learning Centre Far West, Broken Hill',
    'Alesco Secondary College',
    'Alexandra Hills State High School, Capalaba',
    'Alexandra Secondary College, Alexandra',
    'Alexandria Park Community School, Alexandria',
    'Alfred Deakin High School, Deakin',
    'Alia College, Hawthorn East',
    'Alice Miller School, Macedon',
    'Alice Springs Language Centre, Alice Springs',
    'Alice Springs School of the Air, Alice Springs',
    'Alice Springs Steiner School',
    'Alkimos Baptist College, Merriwa',
    'Alkimos College',
    'Alkira Secondary College, Cranbourne North',
    "All Hallows' School, Brisbane",
    'All Saints Anglican School',
    'All Saints Anglican School (International House)',
    'All Saints Catholic College, Liverpool',
    "All Saints College (St Mary's Campus), Maitland",
    'All Saints College, Maitland',
    'All Saints Grammar, Belmore',
    'All Saints Grammar, Primary Campus',
    "All Saints' College, Willetton",
    'All Souls St Gabriels School',
    'Allegra School Coffs Harbour, Coffs Harbour',
    'Allendale East Area School, Allendale East',
    'Allora P-10 State School, Allora',
    'Alpha Omega Senior College, Auburn',
    'Alpha State School, Alpha',
    'Alphington Grammar School, Alphington',
    'Alpurrurulam School, Alpurrurulam',
    'Alstonville High School, Alstonville',
    'Alta-1 College, Caboolture',
    'Alta-1 College, Wangara',
    'Altona College, Altona',
    'Alyangula Area School, Alyangula',
    'Alyarrmandumanja Umbakumba School, Umbakumba',
    'Amanbidji School, Katherine',
    'Amaroo School, Amaroo',
    'Amata Anangu School, Alice Springs',
    'Ambarvale High School',
    'Ambrose Treacy College, Indooroopilly',
    'Amity College, Prestons',
    'Amity College, Shellharbour',
    'Ampilatwatja School, Alice Springs',
    'Andale School, Kew',
    'Angelorum College, Fortitude Valley',
    'Anglican Church Grammar School, East Brisbane',
    'Angurugu Community Education Centre, Alyangula',
    'Angurugu School, Angurugu',
    'Annandale Christian College, Aitkenvale',
    'Anson Street School, Orange',
    'Antonine College (Cedar Campus), Coburg',
    'Antonine College, Pascoe Vale South',
    'Anzac Park Public School, Cammeray',
    'Apollo Bay P-12 College, Apollo Bay',
    'Applecross Senior High School, Ardross',
    'Aquinas Catholic College, Menai',
    'Aquinas College, Ashmore',
    'Aquinas College, Ringwood',
    'Aquinas College, Salter Point',
    'Araluen Christian College, Alice Springs',
    'Aramac State School, Aramac',
    'Aranmore Catholic College, Leederville',
    'Ararat College, Ararat',
    'Arcadia College, Palm Beach',
    'Arden Anglican School, Epping',
    'Ardlethan Central School, Ardlethan',
    'Ardrossan Area School, Ardrossan',
    'Arethusa College, Deception Bay',
    'Ariah Park Central School, Ariah Park',
    'Arlparra School, Sandover',
    'Armadale Education Support Centre, Armadale',
    'Armadale Senior High School, Armadale',
    'Armidale Secondary College',
    'Armstrong Creek School',
    'Arndell Anglican College, Oakville',
    'Arndell School, North Ryde',
    'Arranounbai School, Frenchs Forest',
    'Arthur Phillip High School, Parramatta',
    'Ascham (Senior) School, Edgecliff',
    'Ascham Junior School, Edgecliff',
    'Ascot Vale Heights School',
    'Ashcroft High School, Ashcroft',
    'Ashdale Primary School, Darch',
    'Ashdale Secondary College, Darch',
    'Ashfield Boys High School, Ashfield',
    'Ashford Central School, Ashford',
    'Ashley School, Deloraine',
    'Ashwood High School, Ashwood',
    'Ashwood School, Ashwood',
    'Aspect Central Coast School, Terrigal',
    'Aspect Hunter School, Thornton',
    'Aspect Macarthur School, Cobbitty',
    'Aspect Riverina School - Wagga Wagga Campus, Kooringal',
    'Aspect Riverina School, Albury',
    'Aspect South Coast School, Corrimal',
    'Aspect South East Sydney School, Peakhurst',
    'Aspect Treetop School, Ashford',
    'Aspect Vern Barnett School, Forestville',
    'Aspect Western Sydney School, Wetherill Park',
    'Aspley Special School, Aspley',
    'Aspley State High School, Aspley',
    'Asquith High School, Asquith',
    'Assisi Catholic College, Upper Coomera',
    'Assumption College, Kilmore',
    'Assumption College, Warwick',
    'Athelstone School, Athelstone',
    'Atherton State High School, Atherton',
    'Atlantis Beach Baptist College, Two Rocks',
    'Attadale Primary School, Attadale',
    'Atwell College, Atwell',
    'Auburn Girls High School, Auburn',
    'Auburn High School, Hawthorn East',
    'Aurora College, Lindfield',
    'Aurora School, Blackburn South',
    'Aurora Southern Highlands Steiner School',
    'Aurukun State School, Aurukun',
    'Austin Cove Baptist College, South Yunderup',
    'Australia Law School Pty Ltd, Chatswood',
    'Australian Christian Academy School of Distance Education, Brendale',
    'Australian Christian College - Burnie, Somerset',
    'Australian Christian College - Darling Downs',
    'Australian Christian College - Hobart, Geilston Bay',
    'Australian Christian College - Launceston, Newnham',
    'Australian Christian College - Marsden Park',
    'Australian Christian College - Moreton, Caboolture',
    'Australian Christian College - Singleton, Singleton',
    'Australian Christian College - Southlands, Albany',
    'Australian Christian College Hume, Benalla',
    'Australian Industry Trade College - Brisbane, Spring Hill',
    'Australian Industry Trade College - Redlands, Cleveland',
    'Australian Industry Trade College - Toowoomba, Toowoomba City',
    'Australian International Academy of Education, Coburg North',
    'Australian International Academy, Kellyville Campus',
    'Australian International Academy, Strathfield',
    'Australian International High School, Sydney',
    'Australian International Islamic College, Durack',
    'Australian Islamic College - Henley Brook',
    'Australian Islamic College (Dianella), Dianella',
    'Australian Islamic College (Kewdale)',
    'Australian Islamic College Adelaide, West Croydon',
    'Australian Islamic College of Sydney, Mount Druitt',
    'Australian Performing Arts Grammar School, Glebe',
    'Australian Science and Mathematics School, Bedford Park',
    'Australian Technology and Agricultural College, North Maclean',
    'Australian Trade College North Brisbane, Scarborough',
    'Australind Senior High School, Australind',
    'Autism Queensland Education & Therapy Centre, Sunnybank Hills',
    'Ave Maria College, Aberfeldie',
    'Aveley Secondary College',
    'Avenues College, Windsor Gardens',
    'Avenues Education, Moorabbin',
    'Aviation High',
    'Avila College, Mount Waverley',
    'Avondale School, Cooranbong',
    'Avonvale Education Support Centre, Northam',
    'Awabakal Environmental Education Centre, Dudley',
    'Ayr East State School',
    'Ayr State High School, Ayr',
    'Babinda State School, Babinda',
    'Bacchus Marsh College, Bacchus Marsh',
    'Bacchus Marsh Grammar, Bacchus Marsh',
    'Baden Powell P-9 College, Hoppers Crossing',
    'Baimbridge College, Hamilton',
    'Bairnsdale Christian College',
    'Bairnsdale Secondary College, Bairnsdale',
    'Balaklava High School, Balaklava',
    'Balcatta Senior High School, Balcatta',
    'Balcombe Grammar School, Mount Martha',
    'Baldivis Secondary College, Rockingham',
    'Balga Senior High School, Balga',
    'Ballajura Community College, Ballajura',
    'Ballarat Christian College, Sebastopol',
    'Ballarat Clarendon College, Ballarat',
    'Ballarat Grammar',
    'Ballarat High School, Ballarat',
    'Ballarat Specialist School, Lake Gardens',
    'Ballina Coast High School, Ballina',
    'Balmoral K-12 Community College, Balmoral',
    'Balmoral State High School, Morningside',
    'Balranald Central School, Balranald',
    'Balwyn High School, Balwyn North',
    'Baniyala Garrangali School, East Arnhem',
    'Banksia Park International High School, Banksia Park',
    'Bankstown Girls High School, Bankstown',
    'Bankstown Intensive English Centre, Bankstown',
    'Bankstown Senior College, Bankstown',
    'Bannockburn P-12 College, Bannockburn',
    'Banora Point High School, Banora Point',
    'Baradine Central School, Baradine',
    'Baralaba State School, Baralaba',
    'Barcaldine Prep-12 State School, Barcaldine',
    'Bardie Public School, Ingleburn',
    'Barellan Central School, Barellan',
    'Barham High School, Barham',
    'Baringa Special School, Moe',
    'Baringa State Primary School, Caloundra South',
    'Baringa State Secondary College',
    'Barker College, Hornsby',
    'Barraba Central School, Barraba',
    'Barrenjoey High School, Avalon Beach',
    'Barrett Adolescent Centre Special School, Tennyson',
    'Barunga Community Education Centre, Katherine',
    'Barunga School, Barunga',
    'Barwon Learning Centre, Moree',
    'Barwon Valley School, Belmont',
    'Bass Coast College, San Remo (San Remo Campus)',
    'Bass Coast College, Wonthaggi (Dudley Campus)',
    'Bass Coast Specialist School, Wonthaggi',
    'Bass High School, Bass Hill',
    'Batchelor Area School, Batchelor',
    'Batemans Bay High School, Batehaven',
    'Batemans Bay Public School, Surfside',
    'Bates Drive School, Kareela',
    'Batlow Technology School, Batlow',
    'Baulkham Hills High School, Baulkham Hills',
    'Bayside Christian College Hervey Bay, Urraween',
    'Bayside Christian College, Langwarrin South',
    'Bayside High School, Kogarah',
    'Bayside P-12 College, Williamstown',
    'Bayside Special Developmental School, Moorabbin',
    'Bayswater Secondary College, Bayswater',
    'Bayview College, Portland',
    'Bayview Secondary College, Clarendon Vale',
    'Beaconhills College - Village Campus, Berwick',
    'Beaconhills College, Pakenham',
    'Beaudesert State High School, Beaudesert',
    'Beaufort Secondary College, Beaufort',
    'Beaumaris Secondary College, Beaumaris',
    'Beauty Point Public School, Mosman',
    'Bede Polding College, South Windsor',
    'Bedgerebong Public School',
    'Beechworth Secondary College, Beechworth',
    'Beenleigh Special School, Mount Warren Park',
    'Beenleigh State High School, Beenleigh',
    'Beerwah State High School, Beerwah',
    'Bega High School, Bega',
    'Belconnen High School, Hawker',
    'Belgrave Heights Christian School, Belgrave Heights',
    'Bell State School, Bell',
    'Bellarine Secondary College, Drysdale',
    'Bellarine Secondary College, Ocean Grove',
    'Bellbird Park State Secondary College, Bellbird Park',
    'Bellerive Primary School, Bellerive',
    'Bellfield College, Rossmore',
    'Bellingen High School',
    'Belmont Christian College, Belmont North',
    'Belmont City College, Belmont',
    'Belmont High School, Belmont',
    'Belmont High School, Gateshead',
    'Belmore Boys High School, Belmore',
    'Belmore School, Balwyn',
    'Belridge Secondary College, Beldon',
    'Belridge Secondary Education Support Centre, Beldon',
    'Belvoir Wodonga Special Developmental School, West Wodonga',
    'Belyuen School, Belyuen',
    'Bemin Secondary College',
    'Benalla P-12 College, Benalla',
    'Bendigo Senior Secondary College, Bendigo',
    'Bendigo South East 7-10 Secondary College, Bendigo',
    'Bendigo Special Developmental School, Kangaroo Flat',
    'Benowa State High School, Gold Coast',
    'Bentleigh Secondary College, Bentleigh East',
    'Bentley Park College, Bentley Park',
    'Berengarra School, Kerrimuir',
    'Berri Regional Secondary College',
    'Berry Street School, Noble Park',
    'Berry Street School, Shepparton',
    'Berwick College, Berwick',
    'Beth Rivkah Ladies College',
    'Bethany College, Hurstville',
    'Bethel Christian School, Albany',
    'Bethel Christian School, Mount Druitt',
    'Beverley District High School, Beverley',
    'Beverley Hills Primary School, Doncaster East',
    'Beverley Park School, Campbelltown',
    'Beverly Hills Girls High School, Beverly Hills',
    'Beverly Hills Intensive English Centre, Beverly Hills',
    'Bhaktivedanta Swami Gurukula School, Eungella',
    'Biala Special School, Ballina',
    'Bialik College, Hawthorn',
    'Biggenden State School, Biggenden',
    'Bilgola Plateau Public School',
    'Billabong High School, Culcairn',
    'Billanook College, Mooroolbark',
    'Biloela State High School, Biloela',
    'Bindjiroo Yaluk Community School',
    'Bingara Central School, Bingara',
    'Binnaway Central School, Binnaway',
    'Birali Steiner School',
    'Birchip P-12 School, Birchip',
    'Birdwood High School, Birdwood',
    'Birkdale State School, Birkdale',
    'Birranga College, Clyde North',
    'Birrong Boys High School, Birrong',
    'Birrong Girls High School, Birrong',
    'Bishop Druitt College, Coffs Harbour',
    'Bishop Tyrrell Anglican College, Fletcher',
    "Black Mountain School, O'Connor",
    'Blackall Range Independent School, Kureelpa',
    'Blackall State School, Blackall',
    'Blackburn English Language School, Burwood East',
    'Blackburn High School, Blackburn',
    'Blackfriars Priory School, Prospect',
    'Blackheath and Thornburgh College, Charters Towers',
    'Blacktown Boys High School, Blacktown',
    'Blacktown Girls High School, Blacktown',
    'Blacktown Youth College Incorporated, Hebersham',
    'Blackwater State High School, Blackwater',
    'Blackwood High School, Eden Hills',
    'Blakehurst High School, Blakehurst',
    'Blakes Crossing Christian College, Blakeview',
    'Blaxland High School, Blaxland',
    'Blayney High School, Blayney',
    'Blessed Mary Mackillop College, Jindera',
    'Blue Gum Community School, Hackett',
    'Blue Hills College, Goonellabah',
    'Blue Mountains Grammar School, Wentworth Falls',
    'Bob Hawke College',
    'Boddington District High School, Boddington',
    'Boggabilla Central School, Boggabilla',
    'Bold Park Community School, Wembley',
    'Bomaderry High School, Bomaderry',
    'Bombala High School, Bombala',
    'Bonalbo Central School, Bonalbo',
    'Bonnyrigg High School, Bonnyrigg',
    'Bonnyrigg Public School',
    'Booleroo Centre District School, Booleroo Centre',
    'Boonah State High School, Boonah',
    'Boonah State School',
    'Boorowa Central School, Boorowa',
    'Boort District P-12 School, Boort',
    'Border Christian College, Thurgoona',
    'Border Rivers Christian College, Goondiwindi',
    'Bordertown High School, Bordertown',
    'Borinya, Wangaratta Community Partnership',
    'Boronia K-12 College, Boronia',
    'Borroloola School, Borroloola',
    'Bossley Park High School, Bossley Park',
    'Bothwell District High School, Bothwell',
    'Bourke High School, Bourke',
    'Bourke-Walgett School of Distance Education, Bourke',
    'Bournda Environmental Education Centre, Kalaru',
    'Bowden Brompton Community School, Brompton',
    'Bowen State High School, Bowen',
    'Bowral High School, Bowral',
    'Bowraville Central School, Bowraville',
    'Box Hill High School, Box Hill',
    'Box Hill Senior Secondary College, Mont Albert North',
    'Boyup Brook District High School, Boyup Brook',
    'Bracken Ridge State High School, Sandgate',
    'Bradfield College, St Leonards',
    'Braemar College, Woodend',
    'Braidwood Central School, Braidwood',
    'Brauer College, Warrnambool',
    'Bray Park State High School, Bray Park',
    'Braybrook College, Braybrook',
    'Bremer State High School, Booval',
    'Brentwood Secondary College, Glen Waverley',
    'Brewarrina Central School, Brewarrina',
    'Brewarrina Christian School',
    'Brewongle Environmental Education Centre, Sackville North',
    'Bribie Island State High School, Bribie Island',
    'Bridgetown High School, Bridgetown',
    'Bright P-12 College, Bright',
    'Brighton Grammar School, Brighton',
    'Brighton High School, Brighton',
    'Brighton Secondary College, Brighton East',
    'Brighton Secondary School, North Brighton',
    'Brightwaters Christian College',
    'Brigidine College St Ives, St Ives',
    'Brigidine College, Indooroopilly',
    'Brigidine College, Randwick',
    'Brinbeal Secondary College, Tarneit',
    'Brindabella Christian College - Charnwood campus, Charnwood',
    'Brindabella Christian College, Lyneham',
    'Brisbane Adventist College, Mansfield',
    'Brisbane Bayside State College, Wynnum West',
    "Brisbane Boys' College, Toowong",
    'Brisbane Christian College, Salisbury',
    'Brisbane Girls Grammar School, Brisbane',
    'Brisbane Grammar School, Spring Hill',
    'Brisbane Montessori School, Fig Tree Pocket',
    'Brisbane School of Distance Education, Coorparoo',
    'Brisbane South State Secondary College',
    'Brisbane State High School, South Brisbane',
    'Brisbane Water Secondary College Umina Campus',
    'Brisbane Water Secondary College Woy Woy Campus, Woy Woy',
    'Brisbane Youth Education and Training Centre, Wacol',
    'Broadford Secondary College, Broadford',
    'Broderick Gillawarna School, Revesby',
    'Broken Hill High School, Broken Hill',
    'Brooks High School, Rocherlea',
    'Brookside P-9 College, Caroline Springs',
    'Brookton District High School, Brookton',
    'Broome Senior High School, Broome',
    'Broughton Anglican College',
    'Broughton Anglican College - primary school',
    'Browns Plains State High School, Browns Plains',
    'Bruce Rock District High School, Bruce Rock',
    'Brunswick English Language Centre, Brunswick',
    'Brunswick Secondary College, Brunswick',
    'Buckley Park College, Essendon',
    'Budawang School, Ulladulla',
    'Bulahdelah Central School, Bulahdelah',
    'Bulla Camp School (Gudabijin), Katherine',
    'Bulleen Heights School, Bulleen',
    'Bulli High School, Woonona',
    'Bullimbal School, South Tamworth',
    'Bullsbrook College, Bullsbrook',
    'Bulman School, Bulman Weemol',
    'Bunbury Baptist College',
    'Bunbury Cathedral Grammar School, Gelorup',
    'Bunbury Catholic College, Bunbury',
    'Bunbury Regional Community College, Bunbury',
    'Bunbury Senior High School, Bunbury',
    'Bundaberg Christian College, Bundaberg',
    'Bundaberg North State High School, Bundaberg North',
    'Bundaberg Special School, Norville',
    'Bundaberg State High School, Bundaberg',
    'Bundamba State Secondary College, Booval',
    'Bundarra Central School, Bundarra',
    'Bundoora Secondary College, Bundoora',
    'Bungendore High School',
    'Burbridge School, Koondoola',
    'Burdekin Catholic High School, Ayr',
    'Burdekin Christian College, Ayr',
    'Burdekin School, Ayr',
    'Burgmann Anglican School - Forde Campus, Forde',
    'Burgmann Anglican School, Gungahlin',
    'Burnett State College, Gayndah',
    'Burnett Youth Learning Centre, Elliott',
    'Burnie High School, Cooee',
    'Burnside State High School, Burnside',
    'Burpengary State Secondary College, Burpengary',
    'Burra Burri State School, Jandowae',
    'Burra Community School, Burra',
    'Burrabadine Christian Community School, Dubbo',
    'Burringurrah Remote Community School, Meekatharra',
    'Burwood East Special Developmental School, Burwood East',
    'Burwood Girls High School, Croydon',
    'Busselton Senior High School, Busselton',
    'Butler College, Butler',
    'Bwgcolman Community School, Palm Island',
    'Byford Secondary College, Byford',
    'Byron Bay High School, Byron Bay',
    'Caboolture State High School, Caboolture',
    'Cabra Dominican College, Cumberland Park',
    'Cabramatta High School, Regents Park',
    'Cabramatta Intensive English Centre, Cabramatta',
    'Cairns Hinterland Steiner School, Kuranda',
    'Cairns School of Distance Education, Manunda',
    'Cairns State High School, Cairns',
    'Cairns State Special School, Woree',
    'Cairnsfoot School, Arncliffe',
    'Calamvale Community College, Calamvale',
    'Calamvale Special School, Calamvale',
    'Caldera School, Tweed Heads South',
    'Calderwood Christian School, Calderwood',
    'Calen District State College, Calen',
    'Callaghan College Wallsend Campus',
    'Callaghan College Waratah Campus',
    'Callaghan College, Jesmond',
    'Calliope State High School',
    'Caloundra Christian College, Caloundra',
    'Caloundra City Private School, Pelican Waters',
    'Caloundra State High School, Caloundra',
    'Calrossy Anglican School, Tamworth',
    'Calvary Christian College, Aitkenvale',
    'Calvary Christian College, Carbrook',
    'Calvin Christian School, Kingston',
    'Calwell High School, Calwell',
    'Camberwell Girls Grammar School, Canterbury',
    'Camberwell Grammar School, Balwyn',
    'Camberwell High School, Canterbury',
    'Cambridge Park High School, Cambridge Park',
    'Camden Haven High School, Laurieton',
    'Camden High School, Camden',
    'Camden Park Environmental Education Centre, Menangle',
    'Cammeraygal High School, Crows Nest',
    'Camp Hill State Infants and Primary School, Camp Hill',
    'Campania District School, Campania',
    'Campbell High School, Campbell',
    'Campbell House School, Glenfield',
    'Campbell Town District High School, Campbell Town',
    'Campbelltown Performing Arts High School, Campbelltown',
    'Camperdown College, Camperdown',
    'Canberra College, Phillip',
    'Canberra Girls Grammar School (Senior School), Deakin',
    'Canberra Grammar School, Red Hill',
    'Canberra High School, Jamison Centre',
    'Candlebark School, Romsey',
    'Canley Vale High School, Canley Heights',
    'Cann River P-12 College',
    'Canning College, Bentley',
    'Canning Vale College, Canning Vale',
    'Cannington Community College, Cannington',
    'Cannington Community Education Support Centre, Cannington',
    'Cannon Hill Anglican College',
    'Canobolas Rural Technology High School, Orange',
    'Canowindra High School, Canowindra',
    'Canteen Creek School (Owairtilla School), Canteen Creek',
    'Canterbury Boys High School, Canterbury',
    'Canterbury College, Beenleigh',
    'Canterbury Girls High School, Canterbury',
    'Canterbury Girls Secondary College, Canterbury',
    'Canterbury Primary School, Canterbury',
    'Capalaba State College, Capalaba',
    'Cape Barren Island School, Cape Barren Island',
    'Cape Byron Rudolf Steiner School, Byron Bay',
    'Cape Naturaliste College, Vasse',
    'Capella State High School, Capella',
    'Capricornia School of Distance Education, Emerald',
    'Capricornia School of Distance Education, Rockhampton Campus, Kawana',
    'Carbrook Animal Assisted Learning Centre, Carbrook',
    'Cardiff High School, Cardiff',
    'Cardijn College - Galilee Campus',
    'Cardijn College, Noarlunga Downs',
    'Career Enterprise Centre, Mandurah Dc',
    'Carenne School, Bathurst',
    'Carey Baptist College - Forrestdale',
    'Carey Baptist College, Harrisdale Campus',
    'Carey Baptist Grammar School, Kew campus, Kew',
    'Carey Park Primary School, Carey Park',
    'Carine Senior High School, Carine',
    'Caringbah High School, Caringbah',
    'Carinity Education - Glendyne, Nikenbah',
    'Carinity Education - Rockhampton, Glenlee',
    'Carinity Education - Shalom',
    'Carinity Education - Southside, Sunnybank',
    'Carinity Education, Gladstone',
    'Carinya Christian School, Gunnedah',
    'Carinya Christian School, Tamworth',
    'Carinya School, Mortdale',
    'Caritas College, Port Augusta West',
    'Carlingford High School, Carlingford',
    'Carlisle Adventist College',
    'Carlisle Primary School, Kewdale',
    'Carlton School, Port Augusta',
    'Carmel Adventist College, Carmel',
    'Carmel College, Thornlands',
    'Carmel School, Dianella',
    'Carmichael College, Morayfield',
    'Carnamah District High School, Carnamah',
    'Carnarvon Community College, Carnarvon',
    'Carnegie Primary School, Carnegie',
    'Caroline Chisholm Catholic College, Braybrook',
    'Caroline Chisholm College, Glenmore Park',
    'Caroline Chisholm School - Senior Campus, Chisholm',
    'Carranballac P-9 College, Point Cook',
    'Carroll College, Broulee',
    'Carrum Downs Secondary College, Carrum Downs',
    'Carwatha College P-12, Noble Park',
    'Casey Grammar School, Cranbourne East',
    'Casimir Catholic College, Marrickville',
    'Casino Christian School, North Casino',
    'Casino High School, Casino',
    'Casterton Secondary College, Casterton',
    'Castle Hill High School, Castle Hill',
    'Castlecrag Montessori School, Castlecrag',
    'Castlemaine Secondary College, Castlemaine',
    'Castlemaine Steiner School & Kindergarten, Muckleford',
    'Castlereagh School, Willetton',
    'Casuarina Senior College, Casuarina',
    'Casula High School, Casula',
    'Cathedral College, Wangaratta',
    'Catherine McAuley Catholic College',
    'Catherine McAuley College, Bendigo',
    'Catherine McAuley College, Mackay',
    'Catherine McAuley Westmead',
    'Catholic College Sale, Sale',
    'Catholic College Wodonga, Wodonga',
    'Catholic Ladies College, Eltham',
    'Catholic Regional College Caroline Springs, Caroline Springs',
    'Catholic Regional College North Keilor, Keilor Lodge',
    'Catholic Regional College St Albans',
    'Catholic Regional College Sydenham, Sydenham',
    'CathWest Innovation College, Mount Druitt',
    'Caulfield Grammar School - Malvern Campus, Glen Iris',
    'Caulfield Grammar School, Elsternwick',
    'Caulfield Grammar School, St Kilda East',
    'Cavendish Road State High School, Holland Park',
    'Cecil Andrews College',
    'Cecil Hills High School, Cecil Hills',
    'Cecil Plains State School',
    'Cedar College, Northgate',
    'Cedars Christian College, Unanderra',
    'Ceduna Area School, Ceduna',
    'Centenary Heights State High School, Toowoomba',
    'Centenary State High School, Mount Ommaney',
    'Centennial Park School, Randwick',
    'Central Coast Adventist School, Erina',
    'Central Coast Grammar School, Erina Heights',
    'Central Coast Sports College, Kariong',
    'Central Coast Steiner School, Fountaindale',
    'Central Midlands Senior High School, Moora',
    'Central Sydney Intensive English High School, Alexandria',
    'Central West Leadership Academy',
    'Central Yorke School, Maitland',
    'Centralian Middle School, Alice Springs',
    'Centralian Senior College, Alice Springs',
    'Centre for Higher Education Studies, South Yarra',
    'Cerdon College, Merrylands',
    'Cessnock High School, Cessnock',
    'Chaffey Secondary College, Mildura',
    'Chairo Christian School, Drouin',
    'Chairo Christian School, Pakenham',
    'Challenge Trade and Business College, Collingwood Park',
    'Chalmers Road School, Strathfield',
    'Champion Bay Senior High School, Geraldton',
    'Chancellor State College, Sippy Downs',
    'Chanel College, Gladstone',
    'Charles Campbell College, Paradise',
    'Charles La Trobe P-12 College, Macleod West',
    'Charles Sturt University (Dubbo Campus)',
    'Charleville School of Distance Education',
    'Charleville State High School, Charleville',
    'Charlotte Mason College, Kallangur',
    'Charlton Christian College, Fassifern',
    'Charlton College',
    'Charters Towers School of Distance Education, Millchester',
    'Charters Towers State High School, Charters Towers,',
    'Chatham High School, Taree',
    'Chatswood High School, Chatswood',
    'Cheder Levi Yitzchok Inc',
    'Chelsea Primary School, Chelsea',
    'Cheltenham Girls High School, Cheltenham',
    'Cheltenham Secondary College, Cheltenham',
    'Cherrybrook Technology High School, Cherrybrook',
    'Chester Hill High School, Chester Hill',
    'Chester Hill Intensive English Centre, Chester Hill',
    'Chevalier College Bowral, Burradoo',
    'Chifley College Bidwill Campus, Bidwill',
    'Chifley College Senior Campus, Mount Druitt',
    'Chifley College Shalvey Campus, Shalvey',
    'Chifley College, Dunheved Campus, North St Marys',
    'Chifley College, Mount Druitt',
    'Child Side School, Boyanup',
    'Chinchilla Christian College, Chinchilla',
    'Chinchilla State High School, Chinchilla',
    'Chisholm Catholic College, Bedford',
    'Chisholm Catholic College, Cornubia',
    'Christ Church Grammar School, Claremont',
    'Christ the King Catholic School, Broome',
    'Christadelphian Heritage College, Kemps Creek',
    'Christian Aboriginal Parent-Directed School, Coolgardie',
    'Christian Brothers College, Adelaide',
    'Christian Brothers High School, Lewisham',
    "Christian Brothers' College, Fremantle",
    'Christian College Geelong, Highton',
    'Christies Beach High School, Christie Downs',
    'Christmas Island District High School, Christmas Island',
    'Christway College',
    'Chrysalis School for Rudolf Steiner Education - Bellingen Campus, Bellingen',
    'Chrysalis School for Rudolf Steiner Education, Thora',
    'Churchlands Senior High School, Churchlands',
    'Circular Head Christian School, Smithton',
    'Cire Community School, Berwick',
    'Cire Community School, Hybrid Campus',
    'Cire Community School, Lilydale',
    'Cire Community School, Monbulk',
    'Cire Community School, Yarra Junction',
    'Citipointe Christian College, Carindale',
    'City Campus, Launceston',
    'Clairvaux MacKillop College, Upper Mount Gravatt',
    'Clancy Catholic College, West Hoxton',
    'Clare High School, Clare',
    'Claremont College, Claremont',
    'Claremont College, Randwick',
    'Claremont Special School, Silkstone',
    'Clarence High School, Bellerive',
    'Clarence Valley Anglican School, Grafton',
    'Clarke Road School, Hornsby',
    'Clarkson Community High School, Clarkson',
    'Clayfield College, Clayfield',
    'Clearview Christian College',
    'Clermont State High School, Clermont',
    'Cleve Area School, Cleve',
    'Cleveland District State High School, Cleveland',
    'Cleveland Education and Training Centre, Rowes Bay',
    'Cleveland Street Intensive English High School, Strawberry Hills',
    'Clifford Park Special School, Newtown',
    'Clifton State High School, Clifton',
    'Clinton State School, Clinton',
    'Clonard College, Herne Hill',
    'Cloncurry State School P-12, Cloncurry',
    'Clontarf Aboriginal College, Waterford',
    'Clontarf Beach State High School, Clontarf',
    'Clyde Grammar, Clyde North',
    'Clyde Secondary College',
    'Coastal Lakes College, Lakelands',
    'Cobar High School, Cobar',
    'Cobden Technical School, Cobden',
    'Cobram and District Specialist School, Cobram',
    'Cobram Anglican Grammar School, Cobram',
    'Cobram Secondary College, Cobram',
    'Coburg High School, Coburg',
    'Coburg Special Developmental School, Coburg',
    'Cocos Islands District High School, Cocos Island',
    'Coffs Harbour Bible Church School, Toormina',
    'Coffs Harbour Christian Community School, Bonville',
    'Coffs Harbour High School, Coffs Harbour',
    'Coffs Harbour Learning Centre, Boambee',
    'Coffs Harbour Senior College, Coffs Harbour',
    'Cohuna Secondary College, Cohuna',
    'Colac Secondary College, Colac',
    'Coleambally Central School, Coleambally',
    'Collarenebri Central School, Collarenebri',
    'Collaroy Plateau Public School, Collaroy Plateau',
    'College Row School, Bunbury',
    'Collie Senior High School, Collie',
    'Collingwood Alternative School, Collingwood',
    'Collingwood College, Abbotsford',
    'Collingwood English Language School, Collingwood',
    'Collingwood Park State Secondary College',
    'Collinsville State High School, Collinsville',
    'Colo High School, North Richmond',
    'Columba Catholic College, Charters Towers',
    'Colyton High School, Colyton',
    'Colyton Public School, Mount Druitt',
    'Comet Bay College, Secret Harbour',
    'Communicare Academy, Kenwick',
    'Communities@Work Galilee School, Kambah',
    'Community College Gippsland Ltd, Warragul',
    'Como Secondary College, Como',
    'Concord High School, Concord',
    'Concord School, Bundoora',
    'Concordia College, Highgate',
    'Concordia Lutheran College, Toowoomba',
    'Condell Park Christian School, Condell Park',
    'Condell Park High School, Condell Park',
    'Condobolin High School, Condobolin',
    'Connections High School, ACT',
    'Conservatorium High School, Sydney',
    'Coober Pedy Area School, Coober Pedy',
    'Coodanup College, Coodanup',
    'Cooinda Primary School, East Bunbury',
    'Cook School, Loftus',
    'Cooktown State School, Cooktown',
    'Coolah Central School, Coolah',
    'Coolamon Central School, Coolamon',
    'Cooloola Christian College, Gympie',
    'Coolum Beach Christian College, Coolum Beach',
    'Coolum State High School, Coolum Beach',
    'Coomandook Area School, Coomandook',
    'Coombabah State High School, Runaway Bay',
    'Coomealla High School, Dareton',
    'Coomera Anglican College',
    'Coonabarabran High School, Coonabarabran',
    'Coonamble High School, Coonamble',
    'Coorparoo Secondary College, Coorparoo',
    'Cootamundra High School, Cootamundra',
    'Copperfield College, Sydenham',
    'Corinda State High School, Corinda',
    'Corner Inlet College',
    'Cornerstone Christian College, Busselton',
    'Cornerstone College, Mount Barker',
    'Cornish College, Bangholme',
    'Corowa High School, Corowa',
    'Corpus Christi Catholic High School, Oak Flats',
    'Corpus Christi College, Bateman',
    'Corpus Christi College, Maroubra',
    'Corpus Christi School, Kingsville',
    'Corrigin District High School, Corrigin',
    'Corrimal High School, Corrimal',
    'Corryong College, Corryong',
    'Cosgrove High School, Glenorchy',
    'Cottesloe Primary School, Peppermint Grove',
    'Court Grammar School, Mundijong',
    'Covenant Christian School, Frenchs Forest',
    'Covenant Christian School, Tuggeranong Dc',
    'Covenant College, Bell Post Hill',
    'Cowell Area School, Cowell',
    'Cowra High School, Cowra',
    'Craig Davis College, Cordeaux Heights',
    'Craigieburn Secondary College, Craigieburn',
    'Craigmore High School, Blakeview',
    'Craigslea State High School, Chermside West',
    'Cranbourne East Secondary College',
    'Cranbourne Secondary College, Cranbourne',
    'Cranbourne West Secondary College, Cranbourne West',
    'Cranbrook School, Bellevue Hill',
    'Cranebrook High School, Cranebrook',
    'Creek Street Christian College, Bendigo',
    'Creekside K-9 College, Caroline Springs',
    'Cressy District High School, Cressy',
    'Crestwood High School, Baulkham Hills',
    'Cromehurst School, Lindfield',
    'Cromer Public School, Cromer',
    'Cronulla High School, Cronulla',
    'Crookwell High School, Crookwell',
    'Crossways Lutheran School, Ceduna',
    'Crows Nest State School, Crows Nest',
    'Croxton Special School, Northcote',
    'Croydon Community School, Croydon',
    'Crusoe College, Kangaroo Flat',
    'Cue Primary School',
    'Cumberland High School, Carlingford',
    'Cummins Area School, Cummins',
    'Cunderdin District High School, Cunderdin',
    'Cunnamulla P-12 State School, Cunnamulla',
    'Currimundi Special School, Dicky Beach',
    'Currumbin Community Special School, Currumbin Waters',
    'Cyril Jackson Senior Campus Education Support Centre, Bassendean',
    'Cyril Jackson Senior Campus, Bassendean',
    'Dakabin State High School, Dakabin',
    'Dalby Christian College, Dalby',
    'Dalby State High School, Dalby',
    'Dale Christian School, Armadale',
    'Dalmeny Public School, Prestons',
    'Dalveen State School, Dalveen',
    'Dalwallinu District High School, Dalwallinu',
    'Dalyellup College, Bunbury',
    'Damascus College, Mount Clear',
    'Dandenong High School, Dandenong',
    'Danebank Anglican School for Girls, Hurstville',
    'Dapto High School',
    'Dara School, Morphettville',
    'Daramalan College, Dickson',
    'Dargo Primary School, Dargo',
    'Darling Downs Adventist College',
    'Darling Point Special School, Manly',
    'Darling Range Sports College, Forrestfield',
    'Darling Street High School',
    'Darlington Point Public School, Darlington Point',
    'Darul Ulum College of Victoria, Fawkner',
    'Darwin High School, The Gardens',
    'Darwin Middle School, The Gardens',
    'David Scott School, Fitzroy',
    'Davidson High School, Frenchs Forest',
    'Dawul Remote Community School, Kununurra',
    'Daylesford Secondary College, Daylesford',
    'De La Salle Catholic College, Caringbah',
    'De La Salle College - Kinnoull Campus, Malvern',
    'De La Salle College, Malvern',
    'De La Salle College, Revesby Heights',
    'Deakin University, Burwood',
    'Deception Bay Flexible Learning Centre, Deception Bay',
    'Deception Bay State High School, Deception Bay',
    'Delany College, Granville',
    'Deloraine High School, Deloraine',
    'Deniliquin High School, Deniliquin',
    'Denison College of Secondary Education, Bathurst High Campus',
    'Denison College of Secondary Education, Kelso High Campus',
    'Denistone East Public School, Eastwood',
    'Denmark Senior High School, Denmark',
    'Derby District High School, Derby',
    'Derrinallum P-12 College, Derrinallum',
    'Devonport Christian School, Don',
    'Devonport High School, Devonport',
    'Diamond Valley College, Diamond Creek',
    'Diamond Valley Special Developmental School, Greensborough',
    'Dianella Secondary College Education Support Centre, Dianella',
    'Dianella Secondary College, Daniella',
    'Dickson College, Dickson',
    'Dimboola Memorial Secondary College, Dimboola',
    'Dimbulah State School, Dimbulah',
    'Dirranbandi P-10 State School, Dirranbandi',
    'Discovery Christian College, Agnes Water',
    'Divine Mercy College, Yangebup',
    'Divrei Emineh, Elsternwick',
    'Djarragun College, Gordonvale',
    'Djerriwarrh Community & Education Services - Djerriwarrh Community College, Melton',
    'Dohertys Creek P-9 College',
    'Dominic College, Glenorchy',
    'Domremy College',
    'Don College, Devonport',
    'Donald High School, Donald',
    'Doncaster Secondary College, Doncaster',
    'Dongara District High School, Dongara',
    'Donnybrook District High School, Donnybrook',
    'Donvale Christian College, Donvale',
    'Doomadgee State School, Doomadgee',
    'Doonside High School',
    'Dorchester School, Campbelltown',
    'Dorrigo High School, Dorrigo',
    'Dorroughby Environmental Education Centre, Dorroughby',
    'Dover District School, Dover',
    'Doveton College, Doveton',
    'Dowerin District High School, Dowerin',
    'Downlands College, Toowoomba',
    'DOXA School Bendigo, Bendigo',
    'Dripstone Middle School, Casuarina',
    'Dromana Secondary College, Dromana',
    'Drouin Secondary College, Drouin',
    'Dubbo Christian School, Dubbo',
    'Dubbo College Delroy Campus, Dubbo',
    'Dubbo College Senior Campus, Dubbo',
    'Dubbo College South Campus, Dubbo',
    'Dubbo School of Distance Education, Dubbo',
    'Dudley Public School, Gateshead',
    'Dulwich High School of Visual Arts and Design, Dulwich Hill',
    'Duncraig Senior High School, Duncraig',
    'Dundee Beach School',
    'Dunedoo Central School, Dunedoo',
    'Dungog High School, Dungog',
    "Dunlea Centre, Australia's Original Boys' Town",
    'Dunsborough Christian College',
    'Durham Road School, Bayswater',
    'Durrumbul Public School, Mullumbimby',
    'Dysart State High School, Dysart',
    'Eagle Vale High School, Eagle Vale',
    'Eagleby Learning Centre, Eagleby',
    'Eaglehawk Secondary College, Eaglehawk',
    'Earnshaw State College, Banyo',
    'East Brisbane State School',
    'East Doncaster Secondary College, Doncaster East',
    'East Gippsland Specialist School, Bairnsdale',
    'East Hills Boys High School, Panania',
    'East Hills Girls Technology High School, Panania',
    'East Kimberley College',
    'East Loddon P-12 College, Dingee',
    'East Preston Islamic College, Preston',
    'Eastern Fleurieu R-12 School, Strathalbyn',
    'Eastern Goldfields College, Kalgoorlie',
    'Eastern Goldfields Education Support Centre, Kalgoorlie',
    'Eastern Hills Senior High School, Mount Helena',
    'Eastern Ranges School, Ferntree Gully',
    'Eastern Suburbs Montessori School, Bondi',
    'Eastside Lutheran College, Rosny Park',
    'Eaton Community College, Eaton',
    'Ebenezer Christian College, Prospect',
    'Echuca College, Echuca',
    'EDEN College, Macquarie Fields',
    'Eden Marine High School, Eden',
    'Edenbrook Secondary College',
    'Edenhope College, Edenhope',
    'Edgars Creek Secondary College, Wollert',
    'Edge Hill State School, Edge Hill',
    'Edgeware School, Hurlstone Park',
    'Edi Upper Primary School, Edi Upper',
    'Edinburgh College',
    'Edmund Rice College, Bindoon',
    'Edmund Rice College, Wollongong',
    'EdSpace, Benalla',
    'Edu-Kingdom College, St Albans',
    'Eidsvold State School, Eidsvold',
    "Eileen O'connor Catholic College, Lewisham",
    'Elanora State High School, Elanora',
    'Elderslie High School, Narellan',
    'Elevation Secondary College',
    'Elisabeth Murdoch College, Langwarrin',
    'Elizabeth College, Hobart',
    'Elizabeth Macarthur High School, Narellan Vale',
    'Ellenbrook Christian College, Ellenbrook',
    'Ellenbrook Secondary College, Ellenbrook',
    'Elliott School, Elliott',
    'Elliston Area School, Elliston',
    'Elonera Montessori School, Mount Ousley',
    'Elouera Special School, Cootamundra',
    'Eltham College, Eltham',
    'Eltham High School, Eltham',
    'Elwood College, Elwood',
    'Emanuel Primary School, Randwick',
    'Emanuel School',
    'Emerald Christian College, Emerald',
    'Emerald Secondary College, Emerald',
    'Emerald State High School, Emerald',
    'Emerson School, Dandenong',
    'Emmanuel Anglican College, Ballina',
    'Emmanuel Catholic College, Success',
    'Emmanuel Christian Community School, Girrawheen',
    'Emmanuel Christian School, Rokeby',
    'Emmanuel College, Altona North',
    'Emmanuel College, Carrara',
    'Emmanuel College, Warrnambool',
    'Emmaus Catholic College, Kemps Creek',
    'Emmaus Christian College, South Plympton',
    'Emmaus Christian School, Dickson',
    'Emmaus College, Burwood',
    'Emmaus College, Jimboomba',
    'Emmaus College, Red Hill Rockhampton',
    'Emmaus College, Vermont South',
    'Emmaus College, Victoria',
    'Emmaville Central School, Emmaville',
    'Encounter Lutheran College, Victor Harbor',
    'Endeavour Christian College, Cooktown',
    'Endeavour College, Enfield Plaza',
    'Endeavour Sports High School, Caringbah',
    'Enfield Public School, Enfield',
    'Engadine High School, Engadine',
    'Epenarra School, Wutunugurra',
    'Epping Boys High School, Eastwood',
    'Epping Secondary College, Epping',
    'Erina Heights Public School, Erina Heights',
    'Erina High School, Erina',
    'Erindale College, Wanniassa',
    'Ernabella Anangu School, Ernabella',
    'Eromanga State School, Eromanga',
    'Erskine Park High School, Erskine Park',
    'Esperance Anglican Community School, Esperance',
    'Esperance Education Support Centre, Esperance',
    'Esperance Senior High School, Esperance',
    'Essendon Keilor College, Keilor East',
    'ET Australia Secondary College, Gosford',
    'Eudunda Area School, Eudunda',
    'Euroa Secondary College, Euroa',
    'Evans High School, Blacktown',
    'Evans Intensive English Centre, Blacktown',
    'Evans River Community School, Evans Head',
    'Evelyn Scott School, Denman Prospect',
    'Everton Park State High School, Everton Park',
    'Exeter High School, Exeter',
    'Exeter Primary School, Exeter',
    'Exmouth District High School, Exmouth',
    'Fahan School, Lower Sandy Bay',
    'Fairbridge College, Pinjarra',
    'Fairfield High School, Fairfield',
    'Fairfield Intensive English Centre, Fairfield',
    'Fairhills High School, Knoxfield',
    'Fairholme College, Toowoomba',
    'Fairvale High School, Fairfield',
    'Fairview Heights State School, Wilsonton',
    'Fairview Park Primary School, Fairview Park',
    'Faith Baptist Christian School, Kin Kora',
    'Faith Christian School of Distance Education, Karawatha',
    'Faith Lutheran College - Plainland',
    'Faith Lutheran College - Redlands',
    'Faith Lutheran College, Tanunda',
    'FAME - Flexible Accredited Meaningful Engagement, Christie Downs',
    'Farrer Memorial Agricultural High School, Tamworth',
    'Father John Therry School, Balmain',
    'FCJ College, Benalla',
    'Featherbrook P-9 College, Featherbrook',
    'Fern Bay Public School, Fern Bay',
    'Fernbrook School',
    'Fernhill School, Glenmore Park',
    'Ferny Grove State High School, Ferny Hills',
    'Figtree High School, Figtree',
    'Findon High School, Findon',
    'Finigan School of Distance Education, Queanbeyan',
    'Finley High School, Finley',
    "Fintona Girls' School, Balwyn",
    'Firbank Grammar School, Brighton',
    'Fisher Road School, Dee Why',
    'Fitzroy High School, Fitzroy North',
    'Fitzroy Valley District High School, Fitzroy Crossing',
    'Five Islands School, Booragul',
    'Five Islands Secondary College, Port Kembla',
    'Flagstone State Community College, Jimboomba',
    'Flinders Christian Community College, Carrum Downs',
    'Flinders Christian Community College, Tyabb',
    'Flinders Island District High School, Whitemark',
    'Footscray High School - Barkly Street Years 7-9 Campus',
    'Footscray High School - Kinnear Campus',
    'Footscray High School - Pilgrim 7-9 Campus',
    'Footscray High School, Footscray',
    'Forbes High School, Forbes',
    'Forest Hill College, Burwood East',
    'Forest Lake State High School, Forest Lake',
    'Forestville Public School, Forestville',
    'Forsayth State School',
    'Fort Street High School, Petersham',
    'Fortitude Valley State Secondary College',
    'Foster Secondary College, Foster',
    'Foundation Christian College, Mandurah East',
    'Fountain College - Lynwood Campus, Lynwood',
    'Fountain College, Ferndale campus, Ferndale',
    'Fountain Gate Secondary College, Narre Warren',
    'Fowler Road School, Merrylands',
    'Foxwell State Secondary College',
    'Francis Greenway High School',
    'Frank Dando Sports Academy, Ashwood',
    'Frankston High School, Frankston',
    'Frankston Special Developmental School, Frankston',
    'Fraser Coast Anglican College, Wondunna',
    'Frederick Irwin Anglican School, Mandurah',
    'Freeman Catholic College, Green Valley',
    'Fregon Anangu School, Fregon',
    'Fremantle Christian College, Hamilton Hill',
    'Fremantle College, Beaconsfield',
    'Frensham School, Mittagong',
    'Freshwater Christian College, Brinsmead',
    'Furlong Park School For Deaf Children, Sunshine North',
    'G S Kidd Memorial School, Gunnedah',
    'Galen Catholic College, Wangaratta',
    'Galilee Regional Catholic Primary School, Sth Melbourne',
    'Galstaun College, Ingleside',
    'Galston High School, Galston',
    'Gapuwiyak School, Gapuwiyak',
    'Garden College, Parafield Gardens',
    'Gascoyne Junction Remote Community School, Gascoyne Junction',
    'Gatton State School, Gatton',
    'Gawa Christian School, Galiwinku',
    'Gawler and District College B-12, Evanston',
    'Geelong Baptist College, Lovely Banks',
    'Geelong Grammar School, Corio',
    'Geelong Grammar, Timbertop Campus',
    'Geelong High School, East Geelong',
    'Geelong Lutheran College, Armstrong Creek',
    'Genazzano FCJ College, Kew',
    'Genesis Christian College, Bray Park',
    'Geneva Christian College, Latrobe',
    'Geographe Education Support Centre, Busselton',
    'George Bass School, Bass Hill',
    'Georges River College Hurstville Campus, Hurstville',
    'Georges River College Oatley Senior Campus, Oatley',
    'Georges River College Peakhurst Campus',
    "Georges River College, Girls' campus, Penshurst",
    'Georges River Environmental Education Centre, Chipping Norton',
    'Georges River Grammar',
    'Georgiana Molloy Anglican School - Junior School, Busselton',
    'Georgiana Molloy Anglican School - Senior School, Busselton',
    'Geraldton Christian College, Strathalbyn',
    'Geraldton Flexible Learning Centre, Geraldton',
    'Geraldton Grammar School, Geraldton',
    'Geraldton Senior High School, Geraldton',
    'German International School Sydney, Terrey Hills',
    'Giant Steps Melbourne, Kew',
    'Giant Steps Sydney, Gladesville',
    'Giant Steps Tasmania, Deloraine',
    'Gibberagong Environmental Education Centre, North Turramurra',
    'Gilgandra High School, Gilgandra',
    'Gilmore College, Kwinana',
    'Gilroy Catholic College, Castle Hill',
    'Gilroy Santa Maria College, Ingham',
    'Gilson College, Taylors Hill',
    'Gin Gin State High School, Gin Gin',
    'Gingin District High School, Gingin',
    'Gippsland Grammar',
    'Girl Academy, Wangetti',
    'Girrakool School, Kariong',
    'Girraween High School, Pendle Hill',
    'Girrawheen Senior High School, Girrawheen',
    'Girton Grammar School, Bendigo',
    'Gisborne Montessori School',
    'Gisborne Secondary College, Gisborne',
    'Gladstone High School, Gladstone',
    'Gladstone Park Secondary College, Gladstone Park',
    'Gladstone State High School, Gladstone',
    'Gladstone West State School, West Gladstone',
    'Gladys Newton School, Balga',
    'Glasshouse Christian College, Beerwah',
    'Gleeson College, Golden Grove',
    'Glen Eira College, Caulfield East',
    'Glen Innes High School, Glen Innes',
    'Glen Waverley Secondary College, Glen Waverley',
    'Glenaeon Rudolf Steiner School, Castlecrag',
    'Glenala State High School, Inala Heights',
    'Glenallen School, Glen Waverley',
    'Glendale Technology High School, Glendale',
    'Glenden State School, Glenden',
    'Gleneagles Secondary College, Endeavour Hills',
    'Glenfield Park School, Glenfield',
    'Glengala/Sunshine West Primary School',
    'Glenmore Park High School, Glenmore Park',
    'Glenmore State High School, Rockhampton North',
    'Glenora District School, Bushy Park',
    'Glenquarry Public School, Bowral',
    'Glenroy Private, Glenroy',
    'Glenroy Secondary College, Glenroy',
    'Glenroy Specialist School, Glenroy',
    'Glenunga International High School, Glenunga',
    'Glenwood High School, Glenwood',
    'Global Tropics Future',
    'Glossop Community School, Glossop',
    'Gloucester High School, Gloucester',
    'Gnowangerup District High School, Gnowangerup',
    'Gold Coast Christian College, Reedy Creek',
    'Gold Creek School, Nicholls',
    'Golden Grove High School, Golden Grove',
    'Golden Square Primary School, Golden Square',
    'Goldfields Baptist College, Kalgoorlie Po',
    'Good Counsel College, Innisfail',
    'Good Counsel Primary School, Innisfail',
    'Good News Lutheran College, Werribee',
    'Good Samaritan Catholic College, Bli Bli',
    'Good Samaritan Catholic College, Hinchinbrook',
    'Good Shepherd Catholic College, Mount Isa',
    'Good Shepherd Christian School, Albany Creek',
    'Good Shepherd College, Hamilton',
    'Good Shepherd Lutheran College - St Andrew Campus, Leanyer',
    'Good Shepherd Lutheran College, Howard Springs',
    'Good Shepherd Lutheran College, Noosaville',
    'Goodna Special School, Goodna',
    'Goodooga Central School, Goodooga',
    'Goolwa Secondary College',
    'Goomeri State School, Goomeri',
    'Goondiwindi State High School, Goondiwindi',
    'Gordonvale State High School, Gordonvale',
    'Gorokan High School, Gorokan',
    'Goroke P-12 College, Goroke',
    'Gosford High School, Gosford',
    'Goulburn High School, Goulburn',
    'Goulburn Valley Grammar School, Shepparton',
    'Governor Stirling Senior High School, Woodbridge',
    'Grace Christian College, Leneva',
    'Grace Christian School, Bunbury',
    'Grace Lutheran College (Caboolture Campus)',
    'Grace Lutheran College, Rothwell',
    'Grafton High School, Grafton',
    'Gralee School, Leeton',
    'Grant High School, Mount Gambier East',
    'Granville Boys High School, Granville',
    'Granville South Creative and Performing Arts High School, Guildford',
    'Great Lakes College Senior Campus, Tuncurry',
    'Great Lakes College Tuncurry Campus',
    'Great Lakes College, Forster Campus',
    'Great Southern Grammar School',
    'Greater Shepparton Secondary College, Shepparton',
    'Green Point Christian College, Kincumber',
    'Greenacre Christian College',
    'Greenfields Primary School, Mandurah',
    'Greenlands State School, Stanthorpe',
    'Greensborough Secondary College, Greensborough',
    'Greenvale Secondary College',
    'Greenwood College, Greenwood',
    'Greystanes High School, Wentworthville',
    'Griffith East Public School, Griffith',
    'Griffith High School, Griffith',
    'Grovedale College, Grovedale',
    'Groves Christian College, Kingston',
    'Guildford Grammar Preparatory School, Guildford',
    'Guildford Grammar Senior School, Guildford',
    'Guilford Young College, Glenorchy',
    'Gulargambone Central School, Gulargambone',
    'Gulf Christian College, Normanton',
    'Gulgong High School, Gulgong',
    'Gumdale State School, Gumdale',
    'Gunbalanya School, Gunbalanya',
    'Gundagai High School, Gundagai',
    'Gundaroo Public School, Gundaroo',
    'Gungahlin College, Gungahlin',
    'Gunnedah High School, Gunnedah',
    'Guyra Central School, Guyra',
    'Gymea Technology High School, Gymea',
    'Gympie Flexible Learning Centre, Gympie',
    'Gympie Special School, Gympie',
    'Gympie State High School, Gympie',
    'Haileybury College, Brighton East',
    'Haileybury Rendall School',
    'Hale School, Wembley Downs',
    'Halinda School, Whalan',
    'Hallam Secondary College, Hallam',
    'Hallett Cove School, Hallett Cove',
    'Halls Creek District High School, Halls Creek',
    'Halls Head College Education Support Centre, Halls Head',
    'Halls Head College, Halls Head',
    'Hamilton North Public School, Broadmeadow',
    'Hamilton Parklands School, Hamilton',
    'Hamilton Secondary College, Mitchell Park',
    'Hamlyn Views School, Hamlyn Heights',
    'Hammond Park Secondary College',
    'Hampden Specialist School, Cobden',
    'Hampton East School',
    'Hampton Park Secondary College, Hampton Park',
    'Hampton Senior High School, Morley',
    'Harkaway Hills College',
    'Harrisdale Senior High School, Harrisdale',
    'Harrison School, Harrison',
    'Harristown State High School, Drayton North',
    'Hartford College, Daceyville',
    'Harts Range School, Alice Springs',
    'Harvest Christian College, Kadina',
    'Harvey Senior High School, Harvey',
    'Hastings Secondary College, Port Macquarie Campus',
    'Hastings Secondary College, Westport Campus',
    'Havenlee School, North Nowra',
    'Havenport MSL College, Cockburn Central',
    'Hawker Area School, Hawker',
    'Hawker College, Hawker',
    'Hawkesbury High School, Freemans Reach',
    'Hawkesdale P12 College, Hawkesdale',
    'Hay War Memorial High School, Hay',
    'Hayman Island State School, Hayman Island',
    'Hazel Glen College, Doreen',
    'Healesville High School, Healesville',
    'Heathcote East Public School, Heathcote',
    'Heathcote High School, Engadine',
    'Heathdale Christian College, Werribee',
    'Heatherwood School, Donvale',
    'Heathfield High School, Stirling',
    'Heathmont College, Heathmont',
    'Heatley Secondary College, Aitkenvale',
    'Hedland Senior High School, South Hedland',
    'Heights College, Red Hill Rockhampton',
    'Helena College, Glen Forrest',
    'Helensvale State High School, Helensvale',
    'Helensvale State School, Helensvale',
    'Hellyer College, Burnie',
    'Hemmant Flexible Learning Centre, Hemmant',
    'Henbury School, Wanguri',
    'Henderson College, Irymple',
    'Henley High School, Henley Beach',
    'Hennessy Catholic College, Young',
    'Henry Kendall High School, Gosford',
    'Herberton State School, Herberton',
    'Hercules Road State School, Kippa-Ring',
    'Heritage Christian School, Port Macquarie',
    'Heritage College Knox, Ferntree Gully',
    'Heritage College Lake Macquarie, Morisset',
    'Heritage College Perth',
    'Heritage College, Oakden',
    'Heritage College, Officer campus',
    'Hervey Bay Special School, Kawungan',
    'Hervey Bay State High School, Hervey Bay',
    'Hester Hornbrook Academy, South Melbourne',
    'Heywood District Secondary College, Heywood',
    'Highbury Primary School, Hope Valley',
    'Highfields State Secondary College, Toowoomba',
    'Highlands Christian College, Toowoomba',
    'Highlands School, Mittagong',
    'Highvale Secondary College, Glen Waverley',
    'Highview College, Maryborough',
    'Hillarys Primary School, Hillarys',
    'Hillbrook Anglican School, Everton Park',
    'Hillcrest Christian College, Clyde North',
    'Hillcrest Christian College, Reedy Creek',
    'Hilliard Christian School, Moonah',
    'Hills Adventist College, Kellyville',
    'Hills Christian Community School, Verdun',
    'Hills International College, Jimboomba',
    'Hillside Christian College, Forrestfield',
    'Hillston Central School, Hillston',
    'Hinterland Christian College, Mullumbimby',
    'Hobart City High School',
    'Hobart College, Mount Nelson',
    'Holland Park State High School, Holland Park',
    'Holland Street School, Geraldton',
    'Holman Place School, Cowra',
    'Holmes Grammar School, Melbourne',
    'Holmes Institute Sydney, Sydney',
    'Holmes Secondary College, Melbourne',
    'Holmes Secondary College, Sydney',
    'Holroyd High School, Greystanes',
    'Holroyd Intensive English Centre, Greystanes',
    'Holroyd School, Merrylands',
    'Holsworthy High School, Holsworthy',
    'Holy Cross College, Ellenbrook',
    'Holy Cross College, Ryde',
    'Holy Cross School, Wooloowin',
    'Holy Family School, North Geelong',
    'Holy Spirit Catholic College, Lakemba',
    'Holy Spirit College Mackay',
    'Holy Spirit College, Bellambi',
    'Holy Spirit College, Cooktown',
    'Holy Spirit College, Fitzgibbon',
    'Holy Spirit School, Cranbrook',
    'Holy Spirit School, Strathpine',
    'Holy Trinity Lutheran College, Horsham',
    'Holy Trinity School, Inverell',
    'Home Based Learning Network, Midland Dc',
    'Home Education Association, Petersham',
    'Home Education Network, Victoria',
    'Home Hill State High School, Home Hill',
    'Homebush Boys High School, Homebush South',
    'Homestead Senior Secondary College, Point Cook',
    'Hope Christian College, Brunswick',
    'Hope Christian College, Craigmore',
    'Hopetoun P-12 College, Hopetoun',
    'HopeTown School, Wyong',
    'Hoppers Crossing Secondary College, Hoppers Crossing',
    'Horizon Christian School, Balaklava',
    'Horizons College of Learning and Enrichment, Caboolture',
    'Hornsby Girls High School, Hornsby',
    'Hornsby High School, Hornsby',
    'Horsham College, Horsham',
    'Hoxton Park High School, Hinchinbrook',
    "Hubbard's School, Milton",
    'Hughenden State School, Hughenden',
    'Humanitas High School, Fortitude Valley',
    'Hume Anglican Grammar, Craigieburn',
    'Hume Central Secondary College',
    'Hume Valley School, Broadmeadows',
    'Hunter Christian School, Hunter Region Mc',
    'Hunter River Community School, Metford',
    'Hunter River High School, Raymond Terrace',
    'Hunter School of Performing Arts',
    'Hunter Sports High School, Gateshead',
    'Hunter Trade College, Telarah',
    'Hunter Valley Grammar School, East Maitland',
    'Hunters Hill High School, Hunters Hill',
    'Huntingtower School, Mount Waverley',
    'Huonville High School, Huonville',
    'Hurlstone Agricultural High School, Glenfield',
    'Hurstville Adventist School, Hurstville',
    'Hurstville South Public School, Hurstville',
    'Hymba Yumba Independent School, Springfield',
    'IES College, Spring Hill',
    'Ignatius Park College, Aitkenvale',
    'Ilim College - Glenroy Campus, Glenroy',
    'Ilim College, Dallas',
    'Ilim College, Kiewa Secondary Boys Campus',
    'Illawarra Christian School, Cordeaux Heights',
    'Illawarra Primary School, Blackmans Bay',
    'Illawarra Sports High School, Berkeley',
    'Immaculate Heart Catholic School, West Ipswich',
    'Immaculate Heart College, Lower Chittering',
    'Immanuel College, Novar Gardens',
    'Immanuel Lutheran College, Maroochydore Bc',
    'Inaburra School, Bangor',
    'Inala Flexible Learning Centre, Inala',
    'Indie School - Bacchus March',
    'Indie School - Glenorchy, Glenorchy',
    'Indie School Adelaide',
    'Indie School Albury',
    'Indie School Launceston',
    'Indie School Western Australia, Midland',
    'Indie School Wodonga',
    'Indie School, Logan',
    'Indie School, Mildura',
    'Indie School, Wagga Wagga',
    'Indooroopilly State High School, Indooroopilly',
    'Indulkana Anangu School, Alice Springs',
    'Indulkana Anangu School, Indulkana',
    'Ingham State High School, Ingham',
    'Ingleburn High School, Ingleburn',
    'Inglewood State School, Inglewood',
    'Injune P-10 State School, Injune',
    'Inner Sydney High School, Surry Hills',
    'Innisfail State College - Diverse Learning Centre, Innisfail',
    'Innisfail State College, Innisfail Estate',
    'International Grammar School, Broadway',
    'International Maarif Schools of Australia - Gallipoli Campus, Auburn',
    'International Maarif Schools of Australia - Melbourne Campus',
    'International School of Western Australia, Floreat',
    'Inverell High School',
    'Investigator College, Victor Harbor',
    'Iona College, Charlemont',
    'Iona College, Wynnum',
    'Iona Presentation College, Mosman Park',
    'Ipswich Flexible Learning Centre, Ipswich',
    "Ipswich Girls' Grammar School, Ipswich",
    'Ipswich Grammar School, North Ipswich',
    'Ipswich Special School, Ipswich',
    'Ipswich State High School, Brassall',
    'Ipswich West Special School, West Ipswich',
    "IQRA College, O'Halloran Hill",
    'Irene McCormack Catholic College, Butler',
    'Irfan College, Guildford',
    'Irrawang High School, Raymond Terrace',
    'Irymple Secondary College, Irymple',
    'Isis District State High School, Childers',
    'Islamic College of Brisbane, Karawatha',
    'Islamic College Of Melbourne, Tarneit',
    'Islamic School of Canberra, Weston Creek',
    'Ivanhoe Central School, Ivanhoe',
    "Ivanhoe Girls' Grammar School, Ivanhoe",
    'Ivanhoe Grammar School - Plenty Campus, Mernda',
    'Ivanhoe Grammar School, Ivanhoe',
    'J J Cahill Memorial High School, Rosebery',
    'Jabiru Area School, Jabiru',
    'Jabiru Community College, Bracken Ridge',
    'Jackson School, St Albans',
    'James Busby High School, Green Valley',
    'James Cook Boys High School, Kogarah',
    'James Fallon High School, Lavington',
    'James Meehan High School, Macquarie Fields',
    'James Nash State High School, Gympie',
    'James Ruse Agricultural High School, Carlingford',
    'James Sheahan Catholic High School, Orange',
    'Jamestown Community School, Jamestown',
    'Jamison High School, South Penrith',
    'Jandowae Prep-10 State School, Jandowae',
    'Japanese School of Melbourne, Caulfield South',
    'Jerrabomberra High School, Jerrabomberra',
    'Jerramungup District High School, Jerramungup',
    'Jigalong Remote Community School, Newman',
    'Jilkminggan School, Mataranka',
    'Jindabyne High School',
    'John Calvin Christian College, Armadale',
    'John Calvin School, Launceston',
    'John Calvin School, Yakamia',
    'John Curtin College of the Arts, Fremantle',
    'John Edmondson High School, Hoxton Park',
    'John Fawkner College, Fawkner',
    'John Forrest Secondary College, Morley',
    'John Monash Science School, Monash University',
    'John Paul College, Daisy Hill',
    'John Paul College, Frankston East',
    'John Paul College, Kalgoorlie',
    'John Paul II Catholic School, Clarendon Vale',
    'John Pirie Secondary School, Port Pirie',
    'John Septimus Roe Anglican Community School, Mirrabooka',
    'John Therry Catholic College',
    'John Tonkin College Education Support Centre, Mandurah',
    'John Tonkin College, Mandurah',
    'John Wollaston Anglican Community School, Camillo',
    'John XXIII College, Mount Claremont',
    'Joseph Banks Secondary College',
    'Josiah College, Carrara',
    'JRLF - Senior School, Bridgewater',
    'Jubilee Christian College, Atherton',
    'Junee High School, Junee',
    'Jungdranung Remote Community School, Kununurra',
    'Jurien Bay District High School, Jurien Bay',
    'Kadina Memorial School, Kadina',
    'Kairos Community College, Deception Bay',
    'Kalamunda Secondary Education Support Centre, Kalamunda',
    'Kalamunda Senior High School, Kalamunda',
    'Kalbarri District High School, Kalbarri',
    'Kalgoorlie-Boulder Community High School',
    'Kalianna Special School, Bendigo',
    'Kalinda School, Griffith',
    'Kalkaringi School, Katherine',
    'Kalumburu Remote Community School , Wyndham',
    'Kamaruka, South Yarra',
    'Kamay Botany Bay Environmental Education Centre',
    'Kambala, Rose Bay',
    'Kambalda West District High School, Kambalda West',
    'Kambrya College, Berwick',
    'Kanahooka High School, Dapto',
    'Kandeer School, North Albury',
    'Kandos High School, Kandos',
    'Kangaroo Inn Area School, Millicent',
    'Kangaroo Island Community Education, Kingscote',
    'Kaniva College, Kaniva',
    'Kapunda High School, Kapunda',
    'Karabar High School, Queanbeyan',
    'Karalundi College',
    'Karcultaby Area School, Minnipa',
    'Kardinia International College, Geelong',
    'Kariong Mountains High School, Kariong',
    'Karningul School, Regents Park',
    'Karonga School, Epping',
    'Karoonda Area School, Karoonda',
    'Karratha Senior High School, Karratha',
    'Katandra School, Ormond',
    'Katanning Senior High School, Katanning',
    'Katherine High School, Katherine',
    'Katherine School Of The Air, Katherine',
    'Katoomba High School, Katoomba',
    'Kaurna Plains School, Elizabeth',
    'Kawana Waters State College, Bokarina',
    'Kearnan College, Manjimup',
    'Kedron State High School, Lutwyche',
    'Keebra Park State High School, Southport',
    'Keilor Downs Secondary College, Keilor Downs',
    'Keilor Primary School, Keilor',
    'Keira High School, Fairy Meadow',
    'Keith Area School, Keith',
    'Kellerberrin District High School, Kellerberrin',
    'Kellyville High School, Kellyville',
    'Kellyville Ridge Public School, Kellyville Ridge',
    'Kelmscott Senior High School, Kelmscott',
    'Kelso State School',
    'Kelvin Grove State College, Kelvin Grove',
    'Kempsey Adventist School, Kempsey',
    'Kempsey High School, West Kempsey',
    'Kenmore Park Anangu School',
    'Kenmore State High School, Kenmore',
    'Kennedy Baptist College, Bull Creek',
    'Kensington Community High School, Kensington',
    'Kensington Secondary School, Kensington',
    'Kent Street Senior High School, East Victoria Park',
    'Kenwick School, Kenwick',
    'Kepnock State High School, Bundaberg South',
    'Keppel Sands State School, Keppel Sands',
    'Kerang Christian College, Kerang',
    'Kerang Technical High School, Kerang',
    'Kesser Torah College, Dover Heights',
    'Kew High School, Kew East',
    'Key College, Chapel School campus, Merrylands',
    'Key College, Redfern',
    'Keysborough Secondary College, Springvale South',
    'Kiama High School, Kiama',
    'Kiana School, Tennant Creek',
    'Kiara College, Kiara',
    'Kilbreda College, Mentone',
    'Kilcoy State High School, Kilcoy',
    'Kildare Catholic College, Wagga Wagga',
    'Kildare College, Holden Hill',
    'Kilkivan State School, Kilkivan',
    'Killara High School, Killara',
    'Killarney Heights High School, Killarney Heights',
    'Killarney P-10 State School, Killarney',
    'Killester College, Springvale',
    'Kilvington Grammar School, Ormond',
    'Kimba Area School, Kimba',
    'Kimberley College, Carbrook',
    'Kincoppal, Rose Bay',
    'Kincumber High School, Kincumber',
    'Kindlehill School, Wentworth Falls',
    'King Island District High School, Currie',
    'King Street Public School, Singleton',
    "King's Baptist Grammar School, Modbury North",
    "King's Christian College, Logan campus",
    "King's Christian College, Pimpama campus",
    "King's Christian College, Queensland",
    "King's Christian College, Reedy Creek & KTTC campus",
    "King's College, Warrnambool",
    'Kingaroy State High School, Kingaroy',
    'Kingdom Culture Christian School, Arncliffe',
    'Kings Meadows High School, Kings Meadows',
    'Kingscliff High School, Kingscliff',
    'Kingsford Smith School, Holt',
    'Kingsgrove High School, Kingsgrove',
    'Kingsgrove North High School, Kingsgrove',
    'Kingsley College, North Rockhampton',
    'Kingston Community School, Kingston Se',
    'Kingston High School, Kingston',
    'Kingston International College, Highgate',
    'Kingston State College, Woodridge',
    'Kingsway Christian College, Darch',
    'Kingswood College, Box Hill',
    'Kingswood High School, Kingswood',
    'Kinross College, Kinross',
    'Kinross Wolaroi School, Orange',
    'Kintore Street School, Katherine',
    'Kirrawee High School, Kirrawee',
    'Kirwan State High School, Kirwan',
    'Knox Grammar School, Wahroonga',
    'Kogarah High School, Kogarah',
    'Kogarah Intensive English Centre, Kogarah',
    'Koinonia Christian Academy, Bourke',
    'Kojonup District High School, Kojonup',
    'Kolbe Catholic College, Greenvale',
    'Kolbe Catholic College, Rockingham',
    'Koo Wee Rup Secondary College, Koo Wee Rup',
    'Koonung Secondary College, Mont Albert North',
    'Kooringal High School, Kooringal',
    "Korowa Anglican Girls' School, Glen Iris",
    'Korowal School, Hazelbrook',
    'Korumburra Secondary College, Korumburra',
    'Kotara High School, Adamstown Heights',
    'Kowanyama State School, Kowanyama',
    'Ku-Ring-Gai High School, North Turramurra',
    'Kulin District High School, Kulin',
    'Kulkarriya Community School, Fitzroy Crossing',
    'Kuluin State School, Kuluin',
    'Kuraby Special School, Kuraby',
    'Kuranda District State College, Kuranda',
    'Kurnai College Churchill Campus, Gippsland',
    'Kurnai College Morwell Campus, Gippsland',
    'Kurrambee School, Werrington',
    'Kurrawang Christian Aboriginal Parent-Directed School, Kalgoorlie',
    'Kurri Kurri High School, Kurri Kurri',
    'Kurunjang Secondary College, Melton',
    'Kururrungku Catholic Education Centre, Halls Creek',
    'Kuyper Christian School, North Richmond',
    'Kyabram P-12 College, Kyabram',
    'Kyneton High School',
    'Kyogle High School, Kyogle',
    'La Grange Remote Community School, Broome',
    'La Salle Academy, Bowenfels',
    'La Salle College, Middle Swan',
    'Lachlan Macquarie College, Fairfield West',
    'Laidley District State School, Laidley',
    'Laidley State High School, Laidley',
    'Lajamanu Community Education Centre, Katherine',
    'Lajamanu School, Lajamanu',
    'Lake Bolac College, Lake Bolac',
    'Lake Cargelligo Central School, Lake Cargelligo',
    'Lake Cathie Public School, Lake Cathie',
    'Lake Grace District High School, Lake Grace',
    'Lake Illawarra High School, Warilla',
    'Lake Joondalup Baptist College, Joondalup',
    'Lake Macquarie High School, Booragul',
    'Lake Munmorah High School, Lake Munmorah',
    'Lake Tuggeranong College, Greenway',
    'Lakeland Senior High School, South Lake',
    'Lakes Entrance Secondary College, Lakes Entrance',
    'Lakes Grammar School, Gorokan',
    'Lakeside College, Pakenham',
    'Lakeview Senior College, Caroline Springs',
    'Lalor North Secondary College, Epping',
    'Lalor Secondary College, Lalor',
    'Lambert School, North Hobart',
    'Lambton High School, New Lambton',
    'Lameroo Regional Community School, Lameroo',
    'Landsdale Christian School, Landsdale',
    'Lane Cove Public School, Lane Cove',
    'Lanyon High School, Conder',
    'Lara Secondary College, Lara',
    'Laramba School, Alice Springs',
    'LaSalle Catholic College, Bankstown',
    'Latrobe High School, Latrobe',
    'Launceston Big Picture School, Invermay',
    'Launceston Christian School, Riverside',
    'Launceston Church Grammar School, Mowbray',
    'Launceston College, Launceston',
    "Lauriston Girls' School, Armadale",
    'Lavalla Catholic College, Traralgon',
    'Lavers Hill K-12 College, Lavers Hill',
    'Laverton P-12 College, Laverton',
    'Laverton School, Laverton',
    'Lawrence Hargrave School, Warwick Farm',
    'Laynhapuy Homelands School',
    'Le Fevre High School, Semaphore South',
    'Leaning Tree Steiner School, Geraldton',
    'Lee Street State Special School',
    'Leeming Senior High School Education Support Centre, Leeming',
    'Leeming Senior High School, Leeming',
    'Leeton High School, Leeton',
    'Leeton Public School, Leeton',
    'Leibler Yavneh College, Elsternwick',
    'Leigh Creek Area School, Leigh Creek',
    'Leighland Christian School, Ulverstone',
    'Leinster Community School, Leinster',
    'Leongatha Secondary College, Leongatha',
    'Leonora District High School, Leonora',
    'Les Powell School, Mount Pritchard',
    'Lesmurdie Senior High School, Lesmurdie',
    'Leumeah High School',
    'Lighthouse Christian College Cranbourne, Cranbourne',
    'Lighthouse Christian College, Keysborough',
    'Lighthouse Christian School, Rockhampton',
    'Lightning Ridge Central School, Lightning Ridge',
    'Lilydale District School, Lilydale',
    'Lilydale Heights College, Lilydale',
    'Lilydale High School, Lilydale',
    'Lindfield College',
    'Lindfield Public School, Lindfield',
    'Lindisfarne Anglican Grammar School, Banora Point (Mahers Lane Campus)',
    'Lindsay Park Public School, West Wollongong',
    'Linuwel School Ltd, East Maitland',
    'Lisarow High School, Lisarow',
    'Lithgow High School, Lithgow',
    'Little Yarra Steiner School, Yarra Junction',
    'Liverpool Boys High School, Liverpool',
    'Liverpool Girls High School, Liverpool',
    'Living School, Lismore',
    'Living Waters Lutheran College, Warnbro',
    'Livingstone Christian College, Ormeau',
    'Lock Area School, Lock',
    'Lockhart Central School, Lockhart',
    'Lockhart State School, Lockhart',
    'Lockyer District State High School, Gatton',
    'Logan City Special School, Logan Central',
    'Loganlea State High School, Loganlea',
    'Lomandra School, Campbelltown',
    'Longneck Lagoon Environmental Education Centre, Maraylya',
    'Longreach School of Distance Education, Longreach',
    'Longreach State High School, Longreach',
    'Looma Remote Community School, Derby',
    'Loreto College Coorparoo',
    'Loreto College, Ballarat',
    'Loreto College, Marryatville',
    'Loreto Kirribilli, Kirribilli',
    'Loreto Mandeville Hall, Toorak',
    'Loreto Normanhurst',
    'Lorien Novalis School for Rudolf Steiner Education, Round Corner',
    'Lorne P-12 College, Lorne',
    'Lourdes Hill College, Hawthorne',
    'Lowanna College, Newborough',
    'Lowood State High School, Lowood',
    'Lowther Hall Anglican Grammar School, Essendon',
    'Loxton High School, Loxton',
    'Loyola College, Watsonia',
    'Ltyentye Apurte Catholic School, Santa Teresa',
    'Lucas Heights Community School, Barden Ridge',
    'Lucindale Area School, Lucindale',
    'Lumen Christi Catholic College, Pambula',
    'Lumen Christi College, Martin',
    'Lumen Christi Primary School, Delacombe',
    'Lurnea High School, Lurnea',
    'Lurnea Intensive English Centre, Lurnea',
    'Luther College, Croydon',
    'Lutheran Ormeau Rivers District School, Pimpama',
    'Luurnpa Catholic School, Halls Creek',
    'Lycee Condorcet The International French School Of Sydney',
    'Lyndale Secondary College, Dandenong North',
    'Lyndhurst Secondary College, Cranbourne',
    'Lyneham High School, Lyneham',
    'Lynwood Senior High School, Lynwood',
    'Lysterfield Lake College',
    'Mabel Park State High School, Logan City Dc',
    'Macarthur Adventist College, Macquarie Fields',
    'Macarthur Anglican School',
    'Macarthur Girls High School, Parramatta',
    'MacGregor State High School, Upper Mount Gravatt',
    'Macintyre High School, Inverell',
    'Mackay Christian College, North Mackay',
    'Mackay District Special School, Beaconsfield',
    'Mackay North State High School, Mount Pleasant',
    'Mackay Northern Beaches State High School, Rural View',
    'Mackay State High School, Mackay',
    'Mackenzie State Special School, Mackenzie',
    'MacKillop Catholic College, Mornington',
    'MacKillop Catholic College, Mount Peter',
    'MacKillop Catholic College, Palmerston',
    'MacKillop Catholic College, Warnervale',
    'MacKillop Catholic Regional College, Werribee',
    'MacKillop College, Bathurst',
    'MacKillop College, Port Macquarie',
    'Mackillop Education Caulfield',
    'Mackillop Education, Whittington',
    'MacKillop Specialist School, Whittington',
    'Macksville High School, Macksville',
    'Maclean High School, Maclean',
    'Macleay Vocational College, South Kempsey',
    'Macleod College, Macleod',
    'Macquarie Anglican Grammar School, Dubbo',
    'Macquarie College, Wallsend',
    'Macquarie Fields High School',
    'Macquarie Fields Public School, Macquarie Fields',
    'Macquarie Grammar School, Sydney',
    'Macquarie University Special Education Centre, Macquarie University',
    'MacRobertson Girls High School, Melbourne',
    'Maffra Secondary College, Maffra',
    'Magdalene Catholic College, Narellan',
    'Mainsbridge School, Liverpool',
    'Maitland Christian School, Metford',
    'Maitland Grossmann High School, East Maitland',
    'Maitland High School, East Maitland',
    'Maitland Lutheran School, Maitland',
    'Malanda State High School, Malanda',
    'Malek Fahd Islamic School, Beaumont Hills Campus',
    'Malek Fahd Islamic School, Greenacre Secondary Campus',
    'Malek Fahd Islamic School, Hoxton Park Campus',
    'Maleny State High School, Maleny',
    'Malibu School, Safety Bay',
    'Mallacoota P-12 College, Mallacoota',
    'Malvern Central School, Malvern',
    'Mamaruni School, Minjilang',
    'Mamre Anglican School, Erskine Park',
    'Manangatang P-12 College, Manangatang',
    'Mandurah Baptist College, Mandurah North',
    'Mandurah Catholic College, Mandurah',
    'Manea Senior College, Bunbury',
    'Mango Hill State Secondary College',
    'Manilla Central School, Manilla',
    'Maningrida College, Maningrida',
    'Maningrida Community Education Centre, Winnellie',
    'Manjimup Education Support Centre, Manjimup',
    'Manjimup Senior High School, Manjimup',
    'Manly Vale Public School, Manly Vale',
    'Manning Valley Anglican College, Cundletown',
    'Mannum Community College, Mannum',
    'Manor Lakes P-12 College, Wyndham Vale',
    'Mansfield Autism Statewide Services, Mansfield',
    'Mansfield Rudolf Steiner School, Mansfield',
    'Mansfield Secondary College, Mansfield',
    'Mansfield State High School, Mansfield',
    'Manunda Terrace Primary School, Karama',
    'Mapuru Christian School, Winnellie',
    'Mapuru Yirralka College, Mapuru',
    'Maranatha Christian School, Endeavour Hills',
    'Marble Bar Primary School, Marble Bar',
    'Marcellin College, Bulleen',
    'Marcellin College, Randwick',
    'Marden Senior College, Marden',
    'Mareeba State High School, Mareeba',
    'Margaret Jurd College, Shortland',
    'Margaret River Montessori School',
    'Margaret River Senior High School, Margaret River',
    'Marian Catholic College, Griffith',
    'Marian Catholic College, Kenthurst',
    'Marian College, Ararat',
    'Marian College, Myrtleford',
    'Marian College, Sunshine West',
    'Maribyrnong Secondary College, Maribyrnong',
    'Marist Catholic College North Shore',
    'Marist Catholic College Penshurst, Mortdale',
    'Marist Catholic College, South Hurstville Campus',
    'Marist College Ashgrove, Ashgrove',
    'Marist College Bendigo, Maiden Gully',
    'Marist College Canberra, Pearce',
    'Marist College Eastwood, Eastwood',
    'Marist College Kogarah, Bexley',
    'Marist College, Emerald',
    'Marist Regional College, Burnie',
    'Marist Sisters College, Woolwich',
    'Marist-Sion College, Warragul',
    'Mark Oliphant College, Munno Para West',
    'Marnebek School Cranbourne, Cranbourne East',
    'Maronite College of the Holy Family - Parramatta, Harris Park',
    'Maroochydore State High School, Maroochydore',
    'Maroochydore State School, Maroochydore',
    'Marrara Christian College, Marrara',
    'Marree Aboriginal School, Marree',
    'Marrickville High School, Marrickville',
    'Marrickville Intensive English Centre, Marrickville',
    'Marryatville High School, Marryatville',
    'Marsden High School, West Ryde',
    'Marsden Intensive English Centre, West Ryde',
    'Marsden Park Anglican College',
    'Marsden State High School, Waterford West',
    'Marulan Public School, Marulan',
    'Mary Brooksbank School, Rosemeadow',
    'Mary Immaculate Primary School, Annerley',
    'Mary MacKillop Catholic College, Highfields',
    'Mary MacKillop Catholic College, Wakeley',
    'Mary MacKillop Catholic Regional College, Leongatha',
    'Mary MacKillop College, Norwood South',
    'Mary MacKillop College, Nundah',
    'Mary Valley State College, Imbil',
    'Maryborough Education Centre, Maryborough',
    'Maryborough Special School, Maryborough',
    'Maryborough State High School, Maryborough',
    'Marymede Catholic College, South Morang',
    'Marymount College',
    'Marymount College, Burleigh Waters',
    'Masada College, St Ives',
    'Mastery Schools Australia, Varsity Lakes',
    'Mataranka School, Mataranka',
    'Mater Christi Catholic School, Success',
    'Mater Christi College, Belgrave',
    'Mater Dei Catholic College, Kooringal',
    'Mater Dei College, Edgewater',
    'Mater Dei School, Camden',
    'Mater Maria Catholic College, Warriewood',
    'Matraville Sports High School, Chifley',
    'Matthew Flinders Anglican College, Buderim',
    'Matthew Flinders Girls Secondary College, Geelong',
    'Mawarra Independent School',
    'Mazenod College, Lesmurdie',
    'Mazenod College, Mulgrave',
    'Mbunghara School',
    'McAuley Catholic Central School, Tumut',
    'McAuley Catholic College, Grafton',
    'McAuley College, Beaudesert',
    'McCarthy Catholic College, West Tamworth',
    'McClelland Secondary College, Frankston',
    'McKinnon Secondary College, Mckinnon',
    'Meadowbank Education Trust School, Oatlands',
    'Meadowbank Education Trust, Albury',
    'Meadowbank Education Trust, Armidale',
    'Meadowbank Education Trust, Condobolin',
    'Meadowbank Education Trust, Goulburn',
    'Meadowbank Education Trust, Leeton',
    'Meadowbank Education Trust, Meadowbank',
    'Meadowbank Education Trust, Mount Victoria',
    'Meadowbank Education Trust, Thirroul',
    'Meadowbank Education Trust, Wagga Wagga',
    'Medowie Christian School, Medowie',
    'Meekatharra District High School, Meekatharra',
    'Melba College, Croydon',
    'Melba Copland Secondary School, Melba',
    'Melbourne Girls Grammar',
    "Melbourne Girls' College, Richmond",
    'Melbourne Grammar School, Melbourne',
    'Melbourne High School, South Yarra',
    'Melbourne Indigenous Transition School, Richmond',
    'Melbourne Montessori College, Caulfield South',
    'Melbourne Rudolf Steiner School, Warranwood',
    'Melbourne University',
    'Melonba High School, Melonba',
    'Melrose High School, Pearce',
    'Melton Christian College, Brookfield',
    'Melton Secondary College, Melton',
    'Melton Specialist School, Melton',
    'Melville High School, Kempsey',
    'Melville Senior High School, Melville',
    'Menai High School, Menai Central',
    'Mendooran Central School, Mendooran',
    'Menindee Central School, Menindee',
    'Meningie Area School, Meningie',
    'Mentone Girls Secondary College, Mentone',
    "Mentone Girls' Grammar School, Mentone",
    'Mentone Grammar School, Mentone',
    'Menzies Community School, Menzies',
    'Merbein P-10 College, Merbein',
    'Mercedes College, Perth',
    'Mercedes College, Springfield',
    'Mercy Catholic College, Chatswood',
    'Mercy College, Coburg',
    'Mercy College, Mirrabooka',
    'Mercy Regional College, Camperdown',
    'Merewether High School, Broadmeadow',
    'Merici College, Canberra',
    'Meridan State College, Meridan Plains',
    'Meriden School, Strathfield',
    'Mernda Central P-12 College, Mernda',
    'Mernda Hills Christian College',
    'Merredin College, Merredin',
    'Merri River School',
    'Merriang Special Developmental School, Lalor',
    'Merrimac State High School, Mermaid Waters',
    'Merriwa Central School, Merriwa',
    'Merrylands High School, Merrylands',
    "Methodist Ladies' College, Claremont",
    "Methodist Ladies' College, Kew",
    'Miami State High School, Nobby Beach',
    'Mian School, Dubbo',
    'Mickleham Secondary College',
    'Mid North Christian College, Port Pirie',
    'Mid North Coast Community College - Yulinbal Campus',
    'Mid North Education Centre, Port Pirie',
    'MidCoast Christian College',
    'Middlemount Community School, Middlemount',
    'Mildura Christian College, Irymple',
    'Mildura Senior College, Mildura',
    'Mildura Specialist School, Mildura',
    'Miles State High School, Miles',
    'Milingimbi Community Education Centre, Winnellie',
    'Milingimbi School, Milingimbi',
    'Mill Park Secondary College, Mill Park',
    'Millbank Public School',
    'Miller High School, Miller',
    'Miller Intensive English Centre, Miller',
    'Millicent High School, Millicent',
    'Millmerran State School, Millmerran',
    'Milpera State High School, Chelmer',
    'Miltaburra Area School, Streaky Bay',
    'Milyakburra School, Milyakburra',
    'Mimili Anangu School, Alice Springs',
    'Mimili Anangu School, Mimili',
    'Mimosa Public School, Frenchs Forest',
    'Minarah College',
    'Minaret College, Springvale',
    'Mindarie Senior College, Mindarie',
    'Minerva School, Sutherland',
    'Minlaton District School, Minlaton',
    'Minyerri Community School, Katherine',
    'Minyerri School, Miniyeri',
    'Minyip Primary School, Minyip',
    'Miranda Public School, Miranda',
    'Mirani State High School, Mirani',
    'Mirboo North Secondary College, Mirboo North',
    'Miriam Vale State School, Miriam Vale',
    'Mitcham Girls High School, Kingswood',
    'Mitchell High School, Blacktown',
    'Mitchell State School, Mitchell',
    'Mitchelton Special School, Mitchelton',
    'Mitchelton State High School, Everton Park',
    'MLC School, Burwood',
    'Moama Anglican Grammar, Moama',
    'Modbury High School, Modbury',
    'Modbury Special School, Hope Valley',
    'Model Farms High School, Baulkham Hills',
    'Molong Central School, Molong',
    'Monaro High School, Cooma North',
    'Monash Special Developmental School, Wheelers Hill',
    'Monbulk College, Monbulk',
    'Monivae College, Hamilton',
    'Montagu Bay Primary School, Montagu Bay',
    'Montague Continuing Education Centre, South Melbourne',
    "Monte Sant' Angelo Mercy College",
    'Monterey Secondary College, Frankston North',
    'Montessori International College, Sippy Downs',
    'Montgrove College, Orchard Hills',
    'Montmorency Secondary College, Montmorency',
    'Monto State High School, Monto',
    'Montrose Bay High School, Glenorchy',
    'Moonta Area School, Moonta',
    'Moorebank High School, Chipping Norton',
    'Mooroolbark College, Mooroolbark',
    'Moranbah State High School, Moranbah',
    'Morawa District High School, Morawa',
    'Morayfield East State School, Morayfield',
    'Morayfield State High School, Caboolture',
    'Mordialloc College, Mordialloc',
    'Moree Christian School, Moree',
    'Moree Secondary College Albert St Campus, Moree',
    'Moree Secondary College Carol Ave Campus, Moree East',
    'Moree Secondary College, Moree',
    "Moreton Bay Boys' College",
    'Moreton Bay College, Manly West',
    'Moriah College, Bondi Junction',
    'Morialta Secondary College',
    'Morisset High School, Morisset',
    'Morley Senior High School, Noranda',
    'Mornington Island State School, Gununa',
    'Mornington Secondary College, Mornington',
    'Mornington Special Developmental School, Mornington',
    'Mortlake P-12 College, Mortlake',
    'Moruya High School, Moruya',
    'Mosman High School, Mosman',
    'Moss Vale High School, Moss Vale',
    'Mossman State High School, Mossman',
    'Mother Teresa Catholic College, Baldivis',
    'Mount Alexander College, Flemington',
    'Mount Allan School, Alice Springs',
    'Mount Alvernia College, Kedron',
    'Mount Annan Christian College, Mount Annan',
    'Mount Annan High School, Mount Annan',
    'Mount Austin High School, Wagga Wagga',
    'Mount Barker Community College, Mount Barker',
    'Mount Barker High School, Mount Barker',
    'Mount Barker Waldorf School, Mount Barker',
    'Mount Beauty Secondary College, Mount Beauty',
    'Mount Brown Public School, Dapto',
    'Mount Carmel Catholic College, Varroville',
    'Mount Carmel College, Rosewater',
    'Mount Carmel College, Sandy Bay',
    'Mount Clear College, Mount Clear',
    'Mount Compass Area School, Mount Compass',
    'Mount Eliza Secondary College, Mount Eliza',
    'Mount Erin College, Frankston South',
    'Mount Evelyn Christian School, Mount Evelyn',
    'Mount Fox State School, Mount Fox',
    'Mount Gambier High School, Mount Gambier',
    'Mount Gravatt State High School, Mount Gravatt',
    'Mount Isa Flexible Learning Centre, Sunset',
    'Mount Isa School of the Air, Mount Isa',
    'Mount Isa Special School, Pioneer',
    'Mount Larcom State School, Mount Larcom',
    'Mount Lawley Senior High School, Mount Lawley',
    'Mount Lilydale Mercy College, Lilydale',
    'Mount Magnet District High School, Mount Magnet',
    'Mount Morgan State High School, Mount Morgan',
    'Mount Ommaney Special School, Mount Ommaney',
    'Mount Ridley P-12 College, Craigieburn',
    'Mount Rowan Secondary College, Wendouree',
    'Mount Scopus Memorial College, Burwood',
    'Mount Sinai College, Maroubra',
    'Mount St Benedict College, Pennant Hills',
    'Mount St Bernard College, Herberton',
    "Mount St Joseph Girls' College, Altona",
    'Mount St Joseph Milperra',
    'Mount St Patrick College, Murwillumbah',
    'Mount Stromlo High School, Waramanga',
    'Mount Torrens Christian School',
    'Mount View High School, Cessnock',
    'Mount Waverley Secondary College, Mount Waverley',
    'Mountain Creek State High School, Mooloolaba',
    'Mountain District Community College',
    'Mountain Heights School, Queenstown',
    'Mountain View Adventist College, Doonside',
    'Mountains Christian College, Blackheath',
    'Moura State High School, Moura',
    'Mt Hira College, Keysborough',
    'Mt Maria College, Michelton',
    'Mt Maria College, Petrie',
    "Mt St Michael's College",
    'Mudgee High School, Mudgee',
    'Mudgeeraba Creek State School, Mudgeeraba',
    'Mudgeeraba Special School, Mudgeeraba',
    'Mueller College, Redcliffe',
    'Muirden Senior College, Adelaide',
    'Muirfield High School, North Rocks',
    'Mukinbudin District High School, Mukinbudin',
    'Mulga Bore School, Ti Tree',
    'Mullaley Public School, Mullaley',
    'Mullauna Secondary College, Mitcham',
    'Mullewa District High School, Mullewa',
    'Mullion Creek Public School, Mullion Creek',
    'Mullumbimby High School, Mullumbimby',
    'Mulwaree High School, Goulburn',
    'Mundaring Christian College, Mundaring',
    'Mundubbera State College',
    'Mungalla Silver Lining School, Mutarnee',
    'Mungindi Central School, Mungindi',
    'Murgon State High School, Murgon',
    'Murputja Anangu School, Alice Springs',
    'Murputja Anangu School, Murputja',
    'Murray Bridge High School, Murray Bridge',
    'Murray Bridge Special School, Murray Bridge',
    'Murray Downs School, Alice Springs',
    'Murray High School, Lavington',
    'Murrayville Community College, Murrayville',
    'Murrumba State Secondary College',
    'Murrumburrah High School, Harden',
    'Murtoa College, Murtoa',
    'Murwillumbah High School, Murwillumbah',
    'Musgrave Hill State School, Southport',
    'Music Industry College, Fortitude Valley',
    'Muslim Girls Grammar School, Granville',
    'Muswellbrook High School, Muswellbrook',
    'My Dream Australian Academy',
    'My Independent School',
    'Myrrhee Primary School, Myrrhee',
    'Myrtleford P-12 College, Myrtleford',
    'Nagle Catholic College, Geraldton',
    'Nagle College, Bairnsdale',
    'Nagle College, Blacktown',
    'Namadgi School, Kambah',
    'Nambour Christian College, Woombye',
    'Nambour Special School, Burnside',
    'Nambour State College - Junior School',
    'Nambour State College, Nambour',
    'Nambucca Heads High School, Nambucca Heads',
    'Nambucca Valley Christian Community School, Nambucca Heads',
    'Namoi Valley Christian School',
    'Nanango State High School, Nanango',
    'Nannup District High School, Nannup',
    'Naracoorte High School, Naracoorte',
    'Naranga Special School, Frankston',
    'Narangba Valley State High School, Burpengary',
    'Narara Valley High School, Narara',
    'Narbethong State Special School, Woolloongabba',
    'Narembeen District High School, Narembeen',
    'Naremburn School, Naremburn',
    'Narooma High School, Narooma',
    'Narrabeen Sports High School, North Narrabeen',
    'Narrabri High School, Narrabri',
    'Narrabundah College, Narrabundah',
    'Narrandera High School, Narrandera',
    'Narre Warren South P-12 College, Narre Warren South',
    'Narrogin Senior High School, Narrogin',
    'Narromine High School, Narromine',
    'Nathalia Secondary College, Nathalia',
    'Nautilus Senior College, Port Macquarie',
    'Navigator College, Port Lincoln',
    'Nazareth Catholic College, Kidman Park Campus (10-12)',
    'Nazareth Catholic College: Middle Years (7-9) Flinders Park Campus',
    'Nazareth Catholic Community',
    'Nazareth College, Noble Park North',
    'Neerim District Secondary College, Neerim South',
    'Nelson Park School, Bell Park',
    'Nepean Christian School, Mulgoa',
    'Nepean Creative and Performing Arts High School, Emu Plains',
    'Nepean Special School, Seaford',
    'Nerang State High School, Nerang',
    'Neutral Bay Public School, Neutral Bay',
    "New England Girls' School, Armidale",
    'New Hope Christian School',
    'New Lambton South Public School',
    'New Madinah College',
    'New Norfolk High School, New Norfolk',
    'New South Wales Department of Education',
    'Newborough East Primary School, Newborough',
    'Newbury Primary School, Craigieburn',
    'Newcastle Grammar School, Newcastle',
    'Newcastle High School, Hamilton',
    'Newcastle Junior School, Hillsborough',
    'Newcastle Middle School, Waratah',
    'Newcastle Senior School, Waratah',
    'Newcastle Waldorf School, Glendale',
    'Newcomb Secondary College, Newcomb',
    'Newhaven College, Newhaven',
    'Newington College, Stanmore',
    'Newlands Primary School, Coburg North',
    'Newman Catholic College',
    'Newman College, Churchlands',
    'Newman Senior High School, Newman',
    'Newman Senior Technical College, Port Macquarie',
    'Newstead Christian School, Newstead',
    'Newstead College, Newstead',
    'Newton Moore Education Support Centre, Bunbury',
    'Newton Moore Senior High School, South Bunbury',
    'Newtown High School of Performing Arts, Newtown',
    'Ngaanyatjarra Lands School, Ngaanyatjarra-Giles',
    'Ngalangangpum School, Kununurra',
    'Nganambala School',
    'Nganmarriyanga Community School, Winnellie',
    'Nganmarriyanga School, Nganmarriyanga',
    'Ngaruki Gulgul, Kariong',
    'Ngayuk College, Kalkallo',
    'Ngukurr School, Ngukurr',
    'Ngutu College, Woodville North',
    'Nhill College, Nhill',
    'Nhulunbuy Christian College, Nhulunbuy',
    'Nhulunbuy High School, Nhulunbuy',
    'Nightcliff Middle School, Nightcliff',
    'Niland School, Blackett',
    'Nimbin Central School, Nimbin',
    'Noble Park English Language School, Noble Park',
    'Noble Park Secondary College, Noble Park',
    'Noosa Christian College, Cooroy',
    'Noosa District State High School - Cooroy Campus',
    'Noosa District State High School, Pomona',
    'Noosa Flexible Learning Centre, Sunshine Beach',
    'Noosa Pengari Steiner School, Doonan',
    'Norfolk Island Central School, Norfolk Island',
    'Normanhurst Boys High School, Normanhurst',
    'Normanton State School, Normanton',
    'Norseman District High School, Norseman',
    'North Albany Senior High School, Orana',
    'North Geelong Secondary College, North Geelong',
    'North Gosford Learning Centre, North Gosford',
    'North Ingle School, Ingle Farm',
    'North Lake Senior Campus, Kardinya',
    'North Lakes State College, North Lakes',
    'North Melbourne Primary School',
    'North Rockhampton State High School, Red Hill Rockhampton',
    'North Rocks Public School',
    'North Sydney Boys High School, Crows Nest',
    'North Sydney Girls High School, Crows Nest',
    'North West Christian School, Penguin',
    'Northam Senior High School, Northam',
    'Northampton District High School, Northampton',
    'Northcliffe District High School, Northcliffe',
    'Northcote High School, Northcote',
    'Northern Adelaide Senior College, Elizabeth',
    'Northern Bay P-12 College, Corio',
    'Northern Beaches Christian School, Terrey Hills',
    'Northern Beaches Secondary College Balgowlah Boys Campus, Balgowlah',
    'Northern Beaches Secondary College Cromer Campus, Cromer',
    'Northern Beaches Secondary College Freshwater Senior Campus, Freshwater',
    'Northern Beaches Secondary College Mackellar Girls Campus',
    'Northern Beaches Secondary College, Manly Campus',
    'Northern Beaches State High School, Deeragun',
    'Northern Christian School, Bridgewater',
    'Northern College of the Arts and Technology, Preston',
    'Northern Peninsula Area State College, Bamaga',
    'Northern School For Autism, Reservoir',
    'Northern Territory School of Distance Education, Nightcliff',
    'Northholm Grammar School, Galston',
    'Northlakes High School, San Remo',
    'Northmead Creative and Performing Arts High School, Northmead',
    'Northpine Adventist College, Kallangur',
    'Northshore Christian Grammar School, Alkimos',
    'Northside Christian College, Bundoora',
    'Northside Christian College, Everton Park',
    'Northside Montessori School',
    'Norwest Christian College, Riverstone',
    'Norwood International High School, Magill',
    'Norwood Secondary College, Ringwood',
    'Nossal High School, Narre Warren',
    'Notre Dame College, Bells Creek',
    'Notre Dame College, Shepparton',
    'Novo Education',
    'Nowendoc Public School',
    'Nowra Anglican College, Bomaderry',
    'Nowra Christian School, Nowra',
    'Nowra High School, Nowra',
    'NT Christian College, Marrara',
    'NT Open Education Centre, Casuarina',
    'Ntaria School, Hermannsburg (Ntaria)',
    'Nullagine Primary School',
    'Numbulwar School, Winnellie',
    'Numurkah Secondary College, Numurkah',
    'Nunawading Christian College - Secondary, Nunawading',
    'Nuriootpa High School, Nuriootpa',
    'Nursery Road State Special School, Holland Park West',
    'Nyangatjatjara College, Yulara',
    'Nyikina Mangala Community School',
    'Nyngan High School, Nyngan',
    "O'Connor Catholic College, Armidale",
    "O'Loughlin Catholic College, Casuarina",
    'Oak Flats High School, Oak Flats',
    'Oak Valley Aboriginal School',
    'Oakbank School',
    'Oakey State High School, Oakey',
    'Oakhill College, Castle Hill',
    'Oaklands Central School, Oaklands',
    'Oakleigh Grammar, Oakleigh',
    'Oakwood School - Frankston Campus',
    'Oakwood School, Caulfield North',
    'Oasis College Surry Hills, Surry Hills',
    'Oatlands District High School, Oatlands',
    'Oatley West Public School',
    'Oberon High School, Belmont',
    'Oberon High School, Oberon',
    'Oberthur Primary School, Bull Creek',
    'Observatory Hill Environmental Education Centre, Millers Point',
    'Ocean Reef Senior High School, Ocean Reef',
    'Ocean View P-12 College',
    'Odyssey College',
    'Officer Secondary College, Officer',
    'Ohana College',
    'Olivet Christian College, Campbells Creek',
    'One Arm Point Remote Community School, Broome',
    'OneSchool Global SA, Aberfoyle Park',
    'OneSchool Global Tas, Claremont',
    'Onslow Primary School, Onslow',
    'Ontrack College Emerald, Emerald',
    'Oodnadatta Aboriginal School, Oodnadatta',
    'Open Access College, Marden',
    'Oran Park Anglican College, Narellan',
    'Oran Park High School',
    'Orana Steiner School, Weston',
    'Orange Anglican Grammar School, Orange',
    'Orange Christian School, Orange',
    'Orange Community CAMHS Team, Orange',
    'Orange High School, Orange',
    'Orara High School, Coffs Harbour',
    'Orbost Community College, Orbost',
    'Orion State School, Springsure',
    'Ormeau Woods State High School, Ormeau',
    'Ormiston College, Ormiston',
    'Orroroo Area School, Orroroo',
    'Our Lady Help of Christians Parish School, South Lismore',
    'Our Lady Help of Christians School, Earlville',
    'Our Lady of Fatima School, Rosebud',
    'Our Lady of La Vang School, Flinders Park',
    'Our Lady of Lourdes Primary School, Sunnybank',
    'Our Lady of Mercy Catholic College Burraneer, Cronulla',
    'Our Lady of Mercy College, Australind',
    'Our Lady of Mercy College, Heidelberg',
    'Our Lady of Mercy College, North Parramatta',
    'Our Lady of Sion College, Box Hill',
    'Our Lady of the Annunciation School, Maroubra',
    'Our Lady of the River School, Berri',
    'Our Lady of the Sacred Heart Catholic College, Alice Springs',
    'Our Lady of the Sacred Heart College, Bentleigh',
    'Our Lady of the Sacred Heart College, Enfield',
    'Our Lady of the Sacred Heart College, Kensington',
    'Our Lady of the Sacred Heart Thamarrurr Catholic College, Wadeye',
    'Our Lady of the Southern Cross College, Dalby',
    "Our Lady's College, Annerley",
    'Outdoor School, Bogong',
    'Ouyen P-12 College, Ouyen',
    'Overnewton Anglican Community College, Keilor',
    'Oxford College - Sydney, Sydney',
    'Oxford Falls Grammar School, Oxford Falls',
    'Oxley Christian College, Lilydale',
    'Oxley College',
    'Oxley High School, North Tamworth',
    'Ozford College, Melbourne',
    'Pacific Brook Christian School, Muswellbrook',
    'Pacific Coast Christian School, Banora Point',
    'Pacific Hills Christian School',
    'Pacific Hope Christian School',
    'Pacific Lutheran College, Caloundra',
    'Pacific Online Christian School',
    'Pacific Paradise State School',
    'Pacific Pines Primary School, Pacific Pines',
    'Pacific Pines State High School, Helensvale',
    'Pacific Valley Christian School, Townsend',
    'Padua College, Kedron',
    'Padua College, Mornington',
    'Pakenham Secondary College, Pakenham',
    'Pal Buddhist School, Canley Vale',
    'Pallara State School, Pallara',
    'Palm Beach-Currumbin State High School, Currumbin',
    'Palmerston Christian College',
    'Palmerston College, Driver',
    'Palmview State Secondary College',
    'Palmyra Primary School',
    'Pannawonica School',
    'Papunya School, Alice Springs',
    'Para Hills High School, Para Hills West',
    'Para Meadows School, North Wollongong',
    'Parade College - Preston Campus',
    'Parade College, Bundoora',
    'Parafield Gardens High School, Parafield Gardens',
    'Paralowie School, Salisbury North',
    'Park Ridge State High School, Park Ridge',
    'Parkdale Secondary College, Mordialloc',
    'Parkes Christian School, Parkes',
    'Parkes High School, Parkes',
    'Parklands Christian College, Park Ridge',
    'Parklands High School, Romaine',
    'Parkville College, Malmsbury',
    'Parnngurr Community School, Newman',
    'Parramatta High School, Parramatta',
    'Parramatta Marist High School, Westmead',
    'Parry School, West Tamworth',
    'Pascoe Vale Girls Secondary College, Pascoe Vale',
    'Passfield Park School, Minto',
    "Patrician Brothers' College Blacktown, Blacktown",
    "Patrician Brothers' College Fairfield, Fairfield",
    'Patterson River Secondary College, Seaford',
    'Peace Lutheran College, Kamerunga',
    'Peak Hill Central School, Peak Hill',
    'Peakhurst Public School, Peakhurst',
    'Pedare Christian College, Golden Grove',
    'Peel High School, Tamworth',
    'Pemberton District High School, Pemberton',
    'Pembroke School, Kensington Park',
    'Pendle Hill High School, Wentworthville',
    'Penguin District School, Penguin',
    'Peninsula Grammar, Mount Eliza',
    'Peninsula Specialist College, Dromana',
    'Penleigh & Essendon Grammar School, Keilor East',
    'Pennant Hills High School, Pennant Hills',
    'Penola Catholic College',
    'Penola Catholic College, Glenroy',
    'Penola High School, Penola',
    'Penrhos College, Como',
    'Penrith Anglican College, Orchard Hills',
    'Penrith Christian School, Orchard Hills',
    'Penrith High School, Penrith',
    'Penrith Lakes Environmental Education Centre, Cranebrook',
    'Penrith Valley School, Werrington',
    'Peppimenarti School, Winnellie',
    'Peregian Beach College, Peregian Beach',
    'Peregrine School, Nicholls Rivulet',
    'Perth College, Mount Lawley',
    'Perth Modern School, Subiaco',
    'Perth Montessori School',
    'Perth Waldorf School, Bibra Lake',
    'Peter Carnley Anglican Community School, Kwinana',
    'Peter Lalor Secondary College, Lalor',
    'Peter Moyes Anglican Community School, Quinns Rocks',
    'Peterborough High School, Peterborough',
    'Peterborough School, Warilla',
    'Phoenix P-12 Community College, Sebastopol',
    'Pia Wadjarri Remote Community School, Murchison',
    'Piara Waters Senior High School, Piara Waters',
    'Picnic Point High School, Picnic Point',
    'Picton High School, Picton',
    'Pimlico State High School, Gulliver',
    'Pimpama State Secondary College, Pimpama',
    'Pine Rivers Special School, Lawnton',
    'Pine Rivers State High School, Strathpine',
    'Pinjarra Senior High School, Pinjarra',
    'Pinnacle College, Gilles Plains',
    'Pioneer State High School, Mount Pleasant',
    'Pipalyatjara Anangu School',
    'Pittsworth State High School, Pittsworth',
    'Pittwater High School, Mona Vale',
    'Pittwater House',
    'Pittwater House Junior School',
    'Playford College, Elizabeth',
    'Playford International College, Elizabeth',
    'Plenty River College, South Morang',
    'Plenty Valley Christian College, Doreen',
    'Plenty Valley International Montessori School, St Helena',
    'Plumpton High School, Plumpton',
    'Plumpton House School, Plumpton',
    'Plympton International College, Plympton',
    'Point Cook P-9 College, Point Cook',
    'Point Cook Senior Secondary College, Point Cook',
    'Port Augusta Secondary School, Port Augusta',
    'Port Augusta Special School, Port Augusta',
    'Port Broughton Area School, Port Broughton',
    'Port Dalrymple School, George Town',
    'Port Hacking High School, Miranda',
    'Port Lincoln High School, Port Lincoln',
    'Port Lincoln Special School, Port Lincoln',
    'Port Macquarie Adventist School',
    'Port Melbourne Secondary College',
    'Port Phillip Specialist School, Port Melbourne',
    'Port School, Hamilton Hill',
    'Portland Central School, Portland',
    'Portland Secondary College, Portland',
    'Portside Christian College, New Port',
    'Prahran High School, Windsor',
    'Prairiewood High School, Wetherill Park',
    'Prendiville Catholic College, Joondalup Dc',
    'Presbyterian Ladies College Armidale, Armidale',
    "Presbyterian Ladies' College",
    "Presbyterian Ladies' College Sydney",
    "Presbyterian Ladies' College, Burwood",
    'Prescott College Southern, Morphett Vale',
    'Prescott College, Prospect',
    'Preshil, The Margaret Lyttle Memorial School',
    'Preston High School, Preston',
    'Prince Alfred College, Kent Town',
    'Prince of Peace Lutheran College, Everton Hills',
    'Princes Hill Secondary College, Princes Hill',
    'Proserpine State High School, Proserpine',
    'Prospect High School, Prospect',
    'Prospect Primary School',
    'Proston State School, Proston',
    'Providence Christian College',
    'Pulteney Grammar School, Adelaide',
    'Punchbowl Boys High School, Punchbowl',
    'Purnululu Aboriginal Independent Community School, Kununurra',
    'Putland School, Werrington',
    'Putney Public School',
    "Pymble Ladies' College, Pymble",
    'Pyramid Hill College, Pyramid Hill',
    'Quairading District High School, Quairading',
    'Quakers Hill High School, Quakers Hill',
    'Quandialla Central School, Quandialla',
    'Queanbeyan High School, Queanbeyan',
    'Queechy High School, Norwood',
    'Queensland Academy for Creative Industries, Kelvin Grove',
    'Queensland Academy for Health Sciences, Southport',
    'Queensland Academy for Science Mathematics and Technology, Toowong',
    'Queensland Pathways State College, Coorparoo',
    'Queensland Virtual STEM Academy',
    'Queenwood School',
    'Quilpie State College, Quilpie',
    'Quinalow Prep-10 State School, Quinalow',
    'Quinns Baptist College, Quinns Rocks',
    'Quirindi High School, Quirindi',
    'Quorn Area School, Quorn',
    'Radford College, Bruce',
    'Radiant Life College, East Innisfail',
    'Rainbow P-12 College, Rainbow',
    'Ramingining School, Ramingining',
    'Randwick High School, Randwick',
    'Ravenshoe State School, Ravenshoe',
    'Ravensthorpe District High School, Ravensthorpe',
    'Ravenswood, Gordon',
    'Rawa Community School, Newman',
    'Red Bend Catholic College, Forbes',
    'Red Cliffs Secondary College, Red Cliffs',
    'Red Hill Environmental Education Centre, Gulgong',
    'Red Hill Special School, Red Hill',
    'Red Rock Christian College, Sunbury',
    'Redbank Plains State High School, Redbank Plains',
    'Redbank Plains State School',
    'Redbank School, Westmead',
    'Redcliffe Special School, Redcliffe',
    'Redcliffe State High School, Redcliffe',
    'Reddam House, Woollahra',
    'Redeemer Baptist School, North Parramatta',
    'Redeemer Lutheran College, Biloela',
    'Redeemer Lutheran College, Rochedale',
    'Redfield College, Dural',
    'Redland District Special School, Thornlands',
    'Redlands College, Wellington Point',
    'Redlands District Special School',
    'Redlands, Cremorne',
    'Redlynch State College, Redlynch',
    'Redpa Primary School',
    'Reece High School, Devonport',
    'Regents Park Christian School, Regents Park',
    'Rehoboth Christian College, Kenwick',
    'Renmark High School, Renmark',
    'Reservoir High School, Reservoir',
    'Retaval Preparatory School, Wahroonga',
    'Reynella East College, Reynella',
    'Richard Johnson Anglican College',
    'Richmond Christian College, Ballina',
    'Richmond High School, Richmond',
    'Richmond High School, Richmond, Victoria',
    'Richmond Primary School, Richmond',
    'Richmond State School, Richmond',
    'Ridge View Secondary College, Baldivis',
    'Ringwood Secondary College, Ringwood',
    'Ripley Valley State Secondary College',
    'Rissalah College',
    'Rivendell School, Concord West',
    'River City Christian College, Echuca',
    'River Nile School, North Melbourne',
    'Riverbanks College B-12',
    'Rivercrest Christian College',
    'Rivergum Christian College, Glossop',
    'Riverina Environmental Education Centre, Wagga Wagga',
    'Riverland Special School, Berri',
    'Rivermount College, Yatala',
    'Riverside Christian College, Maryborough',
    'Riverside Girls High School, Gladesville',
    'Riverside High School, Riverside',
    'Riverstone High School, Riverstone',
    'Riverstone Public School, Riverstone',
    'Riverton and District High School, Riverton',
    'Robert Townson High School, Raby',
    'Robina State High School, Robina',
    'Robinson River School',
    'Robinvale College, Robinvale',
    'Rochedale State High School, Rochedale',
    'Rochester Secondary College, Rochester',
    'Rockhampton Flexible Learning Centre, Rockhampton',
    'Rockhampton Girls Grammar School, Rockhampton',
    'Rockhampton North Special School, Frenchville',
    'Rockhampton Special School, Rockhampton',
    'Rockhampton State High School, Rockhampton',
    'Rockingham Montessori School',
    'Rockingham Senior High School Education Support Centre, Rockingham',
    'Rockingham Senior High School, Rockingham',
    'Roebourne District High School, Roebourne',
    'Roleystone Community College, Roleystone',
    'Rollins Primary School, Bell Post Hill',
    'Roma Mitchell Secondary College, Gepps Cross',
    'Roma State College, Roma',
    'Ronald McDonald House, Newcastle',
    'Rooty Hill High School, Rooty Hill',
    'Rosalie Primary School, Shenton Park',
    'Rosamond Special School, Braybrook',
    'Rosary School, Prospect',
    'Rose Bay High School, Lindisfarne',
    'Rose Bay Secondary College, Dover Heights',
    'Rosebank College, Five Dock',
    'Rosebery District School',
    'Rosebud Secondary College, Rosebud',
    'Rosedale State School, Rosedale',
    'Rosehill Secondary College, Niddrie',
    'Rosella Park School, West Gladstone',
    'Roseville College, Roseville',
    'Rosewood State High School, Rosewood',
    'Rosewood State School, Rosewood',
    'Rosny College, Rosny Park',
    'Rossbourne School, Hawthorn',
    'Rossmoyne Senior High School, Rossmoyne',
    'Rostrevor College, Woodforde',
    'Rouse Hill Anglican College, Rouse Hill',
    'Rouse Hill High School, Rouse Hill',
    'Rouse Hill Public School',
    'Rowland Hassall School, Parramatta',
    'Rowville Secondary College, Rowville',
    'Roxburgh College, Roxburgh Park',
    'Roxby Downs Area School, Roxby Downs',
    'Royal Far West School, Manly',
    'Royal National Park Environmental Education Centre, Audley',
    'Rubicon Outdoor School',
    'Rumbalara Environmental Education Centre, Gosford',
    'Runcorn State High School, Runcorn',
    'Rushworth P-12 College, Rushworth',
    'Russian School of Newcastle',
    'Rutherford Technology High School, Rutherford',
    'Rutherglen High School, Rutherglen',
    "Ruyton Girls' School, Kew",
    'Ryan Catholic College, Kirwan',
    'Ryde East Public School, North Ryde',
    'Ryde Secondary College, Ryde',
    'Sacre Coeur, Glen Iris',
    'Sacred Heart Central School, Cootamundra',
    'Sacred Heart College - Champagnat Campus',
    'Sacred Heart College - Marcellin Campus',
    'Sacred Heart College, Kyneton',
    'Sacred Heart College, New Town',
    'Sacred Heart College, Newtown',
    'Sacred Heart College, Sorrento',
    'Sacred Heart College, Yarrawonga',
    "Sacred Heart Girls' College, Oakleigh",
    'Sacred Heart School, Broome',
    'Sacred Heart School, Cootamundra',
    'Safety Bay Senior High School, Waikiki',
    'Sailsbury North Primary School, Sailsbury North',
    'Saint Mary MacKillop College Albury, Jindera',
    'Saint Mary MacKillop Colleges Limited, Wagga Wagga',
    "Saint Stephen's College, Coomera",
    'Saints College BlendED',
    'Saints College, Ballarat',
    'Saints College, BlendED Online',
    'Saints College, Bungaree',
    'Saints College, Colac',
    'Saints College, Fitzroy North',
    'Saints College, Geelong',
    'Saints College, North Melbourne',
    'Saints College, Sunshine',
    'Salamah College, Chester Hill',
    'Sale and District Specialist School, Sale',
    'Sale College Guthridge Campus',
    'Sale College Macalister Campus',
    'Sale College, Sale',
    'Salesian College Chadstone',
    'Salesian College Sunbury',
    'Salisbury East High School, Salisbury East',
    'Salisbury High School, Salisbury North',
    'Saltwater P-9 College, Point Cook',
    'Salvado Catholic College, Byford',
    'Samaritan College, Whyalla',
    'Samford Valley Steiner School, Wights Mountain',
    'Samuel Gilbert Public School, Castle Hill',
    'San Clemente High School, Mayfield',
    'San Damiano College, Yarrabilba',
    'San Sisto College, Carina',
    'Sanderson High School',
    'Sandgate District State High School, Sandgate',
    'Sandringham College, Sandringham',
    'Santa Maria College, Melville',
    'Santa Maria College, Northcote',
    'Santa Sabina College, Strathfield',
    'Santa Sophia Catholic College',
    'Sapphire Coast Anglican College, Bega',
    'Sarah Redfern High School, Minto',
    'Sarina State High School, Sarina',
    'Sathya Sai College, Murwillumbah',
    'Sattler Christian College, Freds Pass',
    'SCEGGS Darlinghurst, Darlinghurst',
    'School of Isolated and Distance Education',
    'School of Languages, West Croydon',
    'School of Special Education Needs: Medical And Mental Health, Perth',
    'School of Special Educational Needs - Behaviour and Engagement, Padbury',
    'Scone Grammar School, Scone',
    'Scone High School, Scone',
    'Scoresby Secondary College, Scoresby',
    'Scotch College Junior School, Torrens Park',
    'Scotch College Senior School, Torrens Park',
    'Scotch College, Claremont',
    'Scotch College, Hawthorn',
    'Scotch Oakburn College, Launceston',
    'Scots All Saints College, Bathurst',
    'Scottsdale High School, Scottsdale',
    'Seaford Secondary College, Seaford',
    'Seaton High School, Seaton',
    'Seaview Christian College',
    'Seaview High School, Seacombe Heights',
    'SEDA College (Victoria), Hawthorn East',
    'SEDA College NT, Fannie Bay',
    'SEDA College SA',
    'SEDA College, Redfern',
    'Sefton High School, Chester Hill',
    'Servite College, Tuart Hill',
    'Seton Catholic College, Samson',
    'Seven Hills High School, Seven Hills',
    'Sevenoaks Senior College, Cannington',
    'Seymour College, Glen Osmond',
    'Seymour College, Seymour',
    'Shailer Park State High School, Loganholme',
    'Shailer Park State School',
    'Shalom College, Bundaberg',
    'Shark Bay School, Denham',
    'Shearwater, the Mullumbimby Steiner School',
    'Sheffield School, Railton',
    'Sheldon College, Sheldon',
    'Shellharbour Anglican College',
    'Shenton College Deaf Education Centre, Shenton Park',
    'Shenton College, Shenton Park',
    'Shepherdson College, Galiwinku',
    'Shepparton ACE Secondary College',
    'Shepparton Christian College, Shepparton',
    'Sherbrooke Community School, Sassafras',
    'Sherwood Hills Christian School, Bradbury',
    'Sherwood State School',
    'Shire Christian School, Barden Ridge',
    'Shirley Smith High School',
    'Shoalhaven High School, Nowra East',
    'Shoalhaven River College',
    'Siena Catholic College, Sippy Downs',
    'Siena College, Camberwell',
    'Silkwood School, Nerang',
    'Simonds Catholic College, West Melbourne',
    'Singleton High School, Singleton',
    'Sir David Brand School, Coolbinia',
    'Sir Eric Woodward Memorial School, St Ives',
    'Sir Joseph Banks High School, Revesby North',
    'Sirius College - Ibrahim Dellal Campus, Sunshine West',
    'Sirius College - Keysborough Campus, Keysborough',
    'Sirius College, Eastmeadows',
    'Sirius College, Meadow Fair Campus, Broadmeadows',
    'Skene Street School Stawell, Stawell',
    'Skillset Senior College, Mitchell',
    'Slacks Creek State School, Daisy Hill',
    "Smith's Hill High School, Wollongong",
    'Smithfield State High School, Smithfield',
    'Smithton High School, Smithton',
    'SMYL Community College, Rockingham',
    'Snowy Mountains Christian School, Cooma North',
    'Snowy Mountains Grammar School, Jindabyne',
    'Snowy Valleys School, Tumut',
    'Somers School Camp, Somers',
    'Somerset College, Mudgeeraba',
    'Somerville House, South Brisbane',
    'Somerville Secondary College, Somerville',
    'Sophia College, Plainland',
    'Sophia Mundi Steiner School, Abbotsford',
    'Sorell School, Sorell',
    'South Coast Baptist College, Waikiki',
    'South Coogee Public School',
    'South Gippsland Specialist School, Leongatha',
    'South Grafton High School, South Grafton',
    'South Oakleigh Secondary College, Oakleigh South',
    'South Sydney High School',
    'South-West John Calvin Christian College, Capel',
    'Southern Autistic School, Bentleigh East',
    'Southern Christian College, Kingston',
    'Southern Cross Baptist Church Christian School, Engadine',
    'Southern Cross Catholic College',
    'Southern Cross Catholic College, Annandale',
    'Southern Cross Catholic College, Scarborough',
    'Southern Cross District High School, Southern Cross',
    'Southern Cross Grammar, Caroline Springs',
    'Southern Cross Public School, Ballina East',
    'Southern Cross School of Distance Education',
    'Southern Highlands Christian School, Bowral',
    'Southern Hills Christian College, Armadale',
    "Southern Montessori School, O'Sullivan Beach",
    'Southern River College, Gosnells',
    'Southern Vales Christian College, Morphett Vale',
    'Southport Flexible Learning Centre, Southport',
    'Southport Special School, Southport',
    'Southport State High School, Southport',
    'Sowilo Community High School, Kelmscott',
    'Specialised Assistance School For Youth (SASY), Adelaide',
    'Spensley Street Primary School, Clifton Hill',
    'Spinifex State College, Mount Isa',
    'Springbank Secondary College, Pasadena',
    'Springfield Central State High School, Springfield',
    'Springside West Secondary College, Plumpton',
    'Springsure State School, Springsure',
    'Springvale Park Special Developmental School, Springvale',
    'Springwood High School, Springwood',
    'Springwood State High School, Springwood',
    "St Agatha's School, Cranbourne",
    'St Agnes Catholic High School, Rooty Hill',
    "St Agnes' Primary School, Port Macquarie",
    "St Aidan's Anglican Girls School, Corinda",
    "St Aidan's School, Maroubra",
    'St Albans East Primary School, St Albans',
    'St Albans Secondary College, St Albans',
    'St Aloysius Catholic College, Huntingfield',
    'St Aloysius College, Adelaide',
    'St Aloysius College, Cronulla',
    'St Aloysius College, North Melbourne',
    "St Aloysius' College, Milsons Point",
    'St Ambrose Parish School, Woodend',
    "St Andrew's Anglican College, Peregian Springs",
    "St Andrew's Cathedral School",
    "St Andrew's Catholic College, Redlynch",
    "St Andrew's Christian College, Knox City Centre",
    "St Andrew's Christian School, Clarenza",
    "St Andrew's Grammar",
    'St Andrews College, Marayong',
    'St Andrews Lutheran College,Tallebudgera',
    "St Angela's Primary School, Castle Hill",
    "St Anne's Central School, Temora",
    "St Anne's College, Kialla",
    "St Anne's School, Seaford",
    'St Anthony of Padua Catholic College',
    "St Anthony's Catholic College, Deeragun",
    "St Anthony's School, Clovelly",
    "St Anthony's School, Kedron",
    "St Anthony's School, Riverside",
    "St Anthony's School, Swan View",
    'St Arnaud Secondary College, St Arnaud',
    'St Augustine Classical Christian College, Kalamunda',
    "St Augustine's College, Augustine Heights",
    "St Augustine's College, Cairns",
    "St Augustine's College, Kyabram",
    "St Augustine's School, Burswood",
    'St Augustines College, Brookvale',
    "St Barbara's Parish School, Roxby Downs",
    "St Bede's Catholic College, Chisholm",
    "St Bede's College, Mentone",
    'St Bedes College, Bentleigh East',
    'St Bedes College, Victoria',
    "St Benedict's Catholic College, Camden",
    "St Benedict's College, Mango Hill",
    "St Bernard's College, Essendon",
    'St Bishoy Coptic Orthodox College, Mount Druitt',
    'St Brendan-Shaw College, Devonport',
    "St Brendan's College, Yeppoon",
    "St Brigid's Catholic College, Lake Munmorah",
    "St Brigid's Catholic School, Evanston",
    "St Brigid's College, Horsham",
    "St Brigid's College, Lesmurdie",
    "St Catherine's Catholic College (Primary), Proserpine",
    "St Catherine's Catholic College (Secondary), Proserpine",
    "St Catherine's Catholic College, Singleton",
    "St Catherine's School, Proserpine",
    "St Catherine's School, Toorak",
    "St Catherine's School, Waverley",
    "St Cecilia's Catholic School, Wyong",
    "St Charbel's College, Punchbowl",
    'St Charles Borromeo School, Templestowe',
    'St Clair High School, St Clair',
    "St Clare's Catholic High School, Hassall Grove",
    "St Clare's College, Manuka",
    "St Clare's College, Waverley",
    "St Clare's High School, Taree",
    "St Clare's School, Lathlain",
    'St Clement of Rome School, Bulleen',
    'St Columba Anglican School, Port Macquarie',
    'St Columba College, Andrews Farm',
    "St Columba's Catholic College, Springwood",
    "St Columba's College, Essendon",
    "St Columba's Primary School, Wilston",
    "St Columban's College, Caboolture",
    "St Columbkille's Catholic School, Corrimal",
    "St David's Parish School, St Agnes",
    "St Dominic's Centre",
    "St Dominic's College, Kingswood",
    "St Dominic's Priory College, North Adelaide",
    "St Dympna's Parish School, Aspley",
    "St Edmund's College Canberra",
    "St Edmund's College, North Ipswich",
    "St Edmund's College, Wahroonga",
    "St Edward's Christian Brothers College, East Gosford",
    'St Eugene College, Burpengary',
    'St Euphemia College, Bankstown',
    "St Finbar's Primary School, Glenbrook",
    'St Francis Catholic College, Edmondson Park',
    'St Francis Catholic College, Melton West',
    'St Francis College, Crestmead',
    'St Francis de Sales College, Mount Barker',
    'St Francis De Sales Regional College, Leeton',
    'St Francis Flexible Learning Centre, Chigwell',
    'St Francis of Assisi Catholic Primary School, Butler',
    'St Francis of Assisi College, Renmark',
    'St Francis Xavier Catholic School, Daly River',
    'St Francis Xavier College Beaconsfield Campus',
    'St Francis Xavier College, Berwick Campus',
    'St Francis Xavier College, Florey',
    'St Francis Xavier College, Officer Campus',
    'St Francis Xavier School, Woolgoolga',
    "St Francis Xavier's College, Hamilton",
    'St Francis Xaviers College, Hamilton',
    "St Francis' School, Maddington",
    "St Gabriel's School for students with special needs, Castle Hill",
    'St George Christian School, Hurstville',
    'St George College, Mile End',
    'St George Girls High School, Kogarah',
    'St George School, Kogarah',
    'St George State High School, St George',
    "St George's Anglican Grammar School, Perth",
    'St Gerard Majella Primary School, Cairns Dc',
    "St Gregory's College, Campbelltown",
    'St Helena Secondary College, Eltham North',
    'St Helens District High School, St Helens',
    "St Hilda's Anglican School for Girls, Mosman Park",
    "St Hilda's School, Southport",
    'St Ignatius College Geelong, Drysdale',
    "St Ignatius' College Riverview, Lane Cove",
    "St Ignatius' College, Athelstone",
    'St Ives High School, St Ives',
    'St James Catholic College',
    'St James College, Brisbane',
    'St James Lutheran College, Urraween',
    "St James' Anglican School, Alkimos",
    "St James' Parish School, Sebastopol",
    "St James' Primary School, Kotara South",
    'St John Bosco College, Engadine',
    'St John Bosco College, Piara Waters',
    'St John Fisher Catholic School, Tumbi Umbi',
    'St John Fisher College, Bracken Ridge',
    'St John Paul College',
    'St John Paul II Catholic College, Schofields',
    'St John Paul II College, Nicholls',
    'St John the Evangelist Catholic High School',
    'St John XXIII Catholic College (Secondary)',
    "St John's Anglican College, Forest Lake",
    "St John's Catholic College, The Gardens",
    "St John's College Preston, Preston",
    "St John's College, Lismore",
    "St John's College, Nambour",
    "St John's Grammar School, Belair",
    "St John's Lutheran School, Kingaroy",
    "St John's Regional College, Dandenong",
    "St John's School",
    'St Johns College, Dubbo',
    'St Johns Park High School, St Johns Park',
    "St Joseph's Catholic College, Aberdeen",
    "St Joseph's Catholic College, East Gosford",
    "St Joseph's Catholic College, Katherine",
    "St Joseph's Catholic Flexible Learning Centre, Alice Springs",
    "St Joseph's Catholic High School, Albion Park",
    "St Joseph's Catholic School",
    "St Joseph's Catholic School, Blayney",
    "St Joseph's Catholic School, Lockhart",
    "St Joseph's Catholic School, Oberon",
    "St Joseph's College Geelong",
    "St Joseph's College Mildura, Mildura",
    "St Joseph's College, Albany",
    "St Joseph's College, Banora Point",
    "St Joseph's College, Brisbane",
    "St Joseph's College, Coomera",
    "St Joseph's College, Echuca",
    "St Joseph's College, Ferntree Gully",
    "St Joseph's College, Hunters Hill",
    "St Joseph's College, Toowoomba",
    "St Joseph's Muswellbrook Campus, Muswellbrook",
    "St Joseph's Nudgee College, Virginia",
    "St Joseph's Park Avenue",
    "St Joseph's Primary School, Merriwa",
    "St Joseph's Regional College, Port Macquarie",
    "St Joseph's School - Peterborough",
    "St Joseph's School Clare",
    "St Joseph's School, Ashgrove West",
    "St Joseph's School, Bombala",
    "St Joseph's School, Bundaberg",
    "St Joseph's School, Busselton",
    "St Joseph's School, Cairns",
    "St Joseph's School, Clermont",
    "St Joseph's School, Glen Innes",
    "St Joseph's School, Hyde Park Castletown",
    "St Joseph's School, Moorebank",
    "St Joseph's School, Mount Isa",
    "St Joseph's School, Murray Bridge",
    "St Joseph's School, Murwillumbah South",
    "St Joseph's School, Northam",
    "St Joseph's School, Oatley",
    "St Joseph's School, Port Lincoln",
    "St Joseph's School, Riverwood",
    "St Joseph's School, Stanthorpe",
    'St Josephs Parish School, Rocky Point',
    "St Kevin's College, Toorak",
    "St Kevin's School, Eastwood",
    'St Laurence Flexible Learning Centre, Broadmeadow',
    "St Laurence's College, South Brisbane",
    "St Leo's Catholic College, Wahroonga",
    "St Leonard's College, Brighton East",
    "St Lucy's School, Wahroonga",
    "St Luke's Anglican School, Kalkie",
    "St Luke's Catholic College, Marsden Park",
    "St Luke's College, Karratha",
    "St Luke's Grammar School, Dee Why",
    "St Margaret Mary's College, Aitkenvale",
    "St Margaret's Anglican Girls School, Ascot",
    "St Margaret's Berwick Grammar",
    "St Margaret's Primary School, East Geelong",
    "St Mark's Anglican Community School - Junior School, Hillarys",
    "St Mark's Anglican Community School, Hillarys",
    "St Mark's College, Port Pirie",
    "St Mark's Coptic Orthodox College, Moorebank",
    "St Maroun's College, Dulwich Hill",
    'St Martin de Porres, Broome',
    "St Martin's Lutheran College, Mount Gambier",
    "St Martin's Primary, Davidson",
    "St Mary and St Mina's Coptic Orthodox College, Bexley",
    'St Mary MacKillop College Canberra',
    'St Mary MacKillop College, Busselton',
    'St Mary MacKillop College, Swan Hill',
    'St Mary MacKillop School - Wallaroo',
    'St Mary of the Angels College, Nathalia',
    'St Mary Star of the Sea Catholic School, Carnarvon',
    'St Mary Star of the Sea College, Wollongong',
    "St Mary's Anglican Girls' School",
    "St Mary's Anglican Girls' School (Junior School)",
    "St Mary's Cathedral College, Sydney",
    "St Mary's Catholic College",
    "St Mary's Catholic College, Casino",
    "St Mary's Catholic College, Earlville",
    "St Mary's Catholic College, Gateshead",
    "St Mary's Catholic School, Kingaroy",
    "St Mary's Catholic School, Wellington",
    "St Mary's College (Maryborough)",
    "St Mary's College for the Deaf, Wantirna South",
    "St Mary's College, Adelaide",
    "St Mary's College, Broome",
    "St Mary's College, Gunnedah",
    "St Mary's College, Hobart",
    "St Mary's College, Ipswich",
    "St Mary's College, Seymour",
    "St Mary's College, St Kilda",
    "St Mary's College, Toowoomba",
    "St Mary's Coptic Orthodox College, Coolaroo",
    "St Mary's Flexible Learning Centre, St Marys",
    "St Mary's Primary School, Hampton",
    "St Mary's School, Alexandra",
    "St Mary's School, Armidale",
    "St Mary's School, Bowen",
    "St Mary's School, Concord",
    "St Mary's School, Erskineville",
    "St Mary's School, Georges Hall",
    "St Mary's School, Goondiwindi",
    "St Mary's School, North Sydney",
    "St Mary's School, Robinvale",
    'St Marys District School',
    'St Marys Senior High School, St Marys',
    'St Matthews Catholic School, Mudgee',
    "St Michael's College, Henley Beach",
    "St Michael's College, Merrimac",
    "St Michael's Collegiate School, Sandy Bay",
    "St Michael's Grammar School, St Kilda",
    "St Michael's Primary School, Kaleen",
    "St Michael's Primary School, Manilla",
    "St Michael's Primary School, Nowra",
    "St Michael's School, Berwick",
    "St Michael's School, Palm Island",
    'St Michaels School, Blacktown',
    "St Monica's College, Cairns",
    "St Monica's College, Epping",
    'St Narsai Assyrian Christian College, Horsley Park',
    'St Norbert College, Cannington',
    "St Patrick's Catholic School, Kogarah",
    "St Patrick's College - Mercy Campus, Mackay",
    "St Patrick's College Ballarat, Ballarat",
    "St Patrick's College Townsville, Townsville",
    "St Patrick's College, Campbelltown",
    "St Patrick's College, Gympie",
    "St Patrick's College, Mackay",
    "St Patrick's College, Prospect",
    "St Patrick's College, Shorncliffe",
    "St Patrick's College, Sutherland",
    "St Patrick's Marist College, Dundas",
    "St Patrick's Parish School, Cooma",
    "St Patrick's School, Ballarat West",
    "St Patrick's School, Emerald",
    "St Patrick's Special School, Dulwich",
    "St Patrick's Technical College, Edinburgh North",
    'St Patricks College, Strathfield',
    "St Paul's Anglican Grammar School",
    "St Paul's Catholic College, Booragul",
    "St Paul's Catholic College, Greystanes",
    "St Paul's College",
    "St Paul's College, Gilles Plains",
    "St Paul's College, Manly",
    "St Paul's College, Walla Walla",
    "St Paul's College, West Kempsey",
    "St Paul's Grammar School, Cranebrook",
    "St Paul's International College, Moss Vale",
    "St Paul's Primary School, Karratha",
    "St Paul's School, Bald Hills",
    "St Peter and Paul's School, Bulimba",
    'St Peter Claver College, Riverview',
    "St Peter's Anglican College, Broulee",
    "St Peter's Catholic College, Tuggerah",
    "St Peter's College, Cranbourne",
    "St Peter's College, St Peters",
    "St Peter's Collegiate Girls' School, Stonyfell",
    "St Peter's Lutheran College, Springfield",
    "St Peter's Parish School, Bentleigh East",
    "St Peter's School, Caboolture",
    "St Peter's School, Rockhampton",
    'St Peters Lutheran College, Indooroopilly',
    "St Philip's Christian College - Cessnock, Nulkaba",
    "St Philip's Christian College - Port Stephens, Salamander Bay",
    "St Philip's Christian College - Waratah, Waratah",
    "St Philip's Christian College Dynamic Learning",
    "St Philip's College, Alice Springs",
    'St Philips Christian College, Gosford',
    'St Philomena School, Park Ridge',
    "St Philomena's School, Moree",
    'St Pius School, Enmore',
    'St Pius X College, Chatswood',
    "St Raphael's Catholic School, Cowra",
    "St Rita's College, Clayfield",
    "St Saviour's College, Toowoomba",
    "St Scholastica's College, Glebe",
    'St Spyridon College, Maroubra',
    "St Stanislaus' College",
    "St Stephen's Catholic College, Mareeba",
    "St Stephen's School, Duncraig",
    "St Stephen's School, Joondalup Dc",
    "St Stephen's School, Pittsworth",
    "St Teresa's Catholic College, Noosaville",
    "St Teresa's College, Abergowrie",
    'St Therese School, Sadleir',
    "St Therese's School, Edmonton",
    'St Thomas Aquinas College, Tynong',
    'St Thomas More College, Sunnybank',
    'St Thomas More Primary School, Sunshine Beach',
    'St Thomas of Villanova Parish School, Mareeba',
    "St Ursula's College",
    "St Ursula's College, Kingsgrove",
    "St Ursula's College, Toowoomba",
    "St Vincent's College, Ashfield",
    "St Vincent's College, Potts Point",
    "St Virgil's College, Hobart",
    "St Xavier's Primary School, Gunnedah",
    'Staines Memorial College, Redbank Plains',
    'Stanthorpe State High School, Stanthorpe',
    'Star of the Sea Catholic College, George Town',
    'Star of the Sea College, Brighton',
    'Staughton College, Melton South',
    'Stawell Secondary College, Stawell',
    'Stella Maris Catholic Primary School, Point Cook',
    'Stella Maris College, Manly',
    'Stewart House School, Curl Curl',
    "Strathcona Baptist Girls' Grammar",
    'Strathfield Girls High School, Strathfield',
    'Strathfield South High School, Enfield',
    'Strathmore Secondary College, Strathmore',
    'Streaky Bay Area School, Streaky Bay',
    'Strelley Community School, Port Hedland',
    'Stretton State College, Sunnybank Hills',
    'Sts Peter and Paul Primary School, Garran',
    'Stuartholme School, Toowong',
    'Summerland Christian College, Lismore Heights',
    'Sunbury And Macedon Ranges Specialist School, Sunbury',
    'Sunbury College, Sunbury',
    'Sunbury Downs Secondary College, Sunbury',
    'Suncoast Christian College, Woombye',
    'Suneden Specialist School, Mitchell Park',
    'Sunnybank Hills State School, Sunnybank Hills',
    'Sunnybank Special School, Sunnybank',
    'Sunnybank State High School, Sunnybank',
    'Sunrise Christian School Naracoorte',
    'Sunrise Christian School, Marion',
    'Sunrise Christian School, Whyalla, Whyalla Norrie',
    'Sunshine Beach State High School, Sunshine Beach',
    'Sunshine Christian School, Sunshine',
    'Sunshine Coast Grammar School, Forest Glen',
    'Sunshine College, Sunshine',
    'Sunshine Special Developmental School, Sunshine',
    'Surat State School, Surat',
    'Surf Coast Secondary College, Torquay',
    'Surveyors Creek Public School, Glenmore Park',
    'Sussex Inlet Public School',
    'Sutherland Shire Montessori School, Gymea',
    'Suzanne Cory High School, Werribee',
    'Swan Christian College Junior, Midland',
    'Swan Christian College Senior, Midland',
    'Swan Hill College, Swan Hill',
    'Swan Hill Specialist School, Swan Hill',
    'Swan Reach Area School, Swan Reach',
    'Swan Valley Anglican Community School, Ellenbrook',
    'Swan View Senior High School, Swan View',
    'Swansea High School, Swansea',
    'Swifts Creek P-12 School, Swifts Creek',
    'Swinburne Senior Secondary College, Hawthorn',
    'Sydney Adventist School Auburn, Auburn',
    'Sydney Boys High School, Surry Hills',
    'Sydney Church of England Grammar School, North Sydney',
    'Sydney Distance Education High School',
    'Sydney Girls High School, Surry Hills',
    'Sydney Grammar School, Darlinghurst',
    'Sydney Japanese International School, Terrey Hills',
    'Sydney Montessori School, Gymea',
    'Sydney Road Community School, Brunswick',
    'Sydney Science College, Epping',
    'Sydney Secondary College Blackwattle Bay Campus, Glebe',
    'Sydney Secondary College, Leichhardt',
    'Sydney Secondary College, Rozelle',
    'Sydney Technical High School, Bexley',
    'Sylvania High School, Sylvania',
    'Sylvanvale School, Kirrawee',
    'Tagai State College, Thursday Island',
    'Tallangatta Secondary College, Tallangatta',
    'Tallowood School, Kellyville',
    'Tambo State School, Tambo',
    'Tamborine Mountain College, North Tamborine',
    'Tamborine Mountain State High School, North Tamborine',
    'Taminmin College, Humpty Doo',
    'Tamworth High School, South Tamworth',
    'Tangara School For Girls, Cherrybrook',
    'Tangara School, Mittagong',
    'Tannum Sands State High School, Tannum Sands',
    'Tannymorel State School',
    'Taqwa School, Spence',
    'Tara Anglican School for Girls, North Parramatta',
    'Tara Shire State College, Tara',
    'Tarago Public School, Tarago',
    'Taree High School, Taree',
    'Tarneit P-9 College, Tarneit',
    'Tarneit Senior College, Tarneit',
    'Taroom State School, Taroom',
    'Taroona High School, Taroona',
    'Tarremah Steiner School, Huntingfield',
    'Tasman District School, Nubeena',
    'Tasmanian eSchool',
    'Tatachilla Lutheran College, Mclaren Vale',
    "Taylor's College, Melbourne",
    'Taylors College Sydney, Waterloo',
    'Taylors Hill Primary School, Taylors Hill',
    'Taylors Lakes Secondary College, Taylors Lakes',
    'Tea Gardens Public School',
    'Tec-NQ, Douglas',
    'Telopea Park School, Barton',
    'Temora High School, Temora',
    'Tempe High School, Tempe',
    'Temple Christian College, Mile End',
    'Temple Christian College, Paralowie',
    'Templestowe College, Templestowe Lower',
    'Tenison Woods College, Mount Gambier',
    'Tennant Creek High School, Tennant Creek',
    'Tenterfield High School, Tenterfield',
    'Terang College, Terang',
    'Terrigal High School, Terrigal',
    'Texas P-10 State School, Texas',
    'Thalgarrah Environmental Education Centre, Armidale',
    'The Alpine School',
    'The Alpine School, Cooma',
    'The Anglican School Googong, Googong',
    'The Armidale School, Armidale',
    'The Armidale Waldorf School, Armidale',
    'The Athena School, Newtown',
    'The Beach School, Allambie Heights',
    'The Beehive Montessori School, Mosman Park',
    'The Bidgee School, Wagga Wagga',
    'The Bowen College, Maroubra',
    'The BUSY School, Cairns',
    'The Canberra College, Phillip',
    'The Cathedral College, Rockhampton',
    'The Cathedral School of St Anne and St James, Aitkenvale',
    'The Centre Education Programme, Kingston',
    'The Crescent School, Goulburn',
    'The Essington School',
    'The Federation College',
    'The Forest High School, Frenchs Forest',
    "The Friends' School",
    'The Gap State High School, The Gap',
    'The Geelong College, Newtown',
    'The Gippsland Tech School',
    'The Glennie School, Toowoomba',
    'The Grange P-12 College, Hoppers Crossing',
    'The Grove Education Centre, Woodville',
    'The Hamilton and Alexandra College, Hamilton',
    'The Heights School, Modbury Heights',
    'The Henry Lawson High School, Grenfell',
    'The Hills Grammar School',
    'The Hills Montessori School, Aldgate',
    'The Hills Montessori School, West Pennant Hills',
    'The Hills School, Northmead',
    'The Hills Sports High School, Seven Hills',
    'The Hutchins School, Sandy Bay',
    'The Illawarra Grammar School, Figtree',
    'The Industry School, Brisbane',
    'The Industry School, Maroochydore',
    'The Industry School, North Ipswich',
    'The Industry School, Redlands',
    'The Industry School, Robina',
    'The Industry School, Toowoomba',
    'The International Chinese School, Chatswood',
    'The Jannali High School',
    'The Japanese School in Perth, City Beach',
    'The John Berne School, Lewisham',
    'The Joseph Varga School, Randwick',
    'The King David School, Armadale',
    "The King's College, Wellard",
    "The King's School, Parramatta",
    'The Knox School, Knox City Centre',
    'The Kooralbyn International School, Kooralbyn',
    'The Lakes Christian College, Castlereagh',
    'The Lakes College, North Lakes',
    'The Lakes South Morang College',
    'The Marian School, Hyde Park Castletown',
    'The McDonald College, North Strathfield',
    'The Montessori School, Kingsley',
    'The Nature School, Port Macquarie',
    'The Ngaanyatjarra Lands School, Alice Springs',
    'The Pavilion School, East Preston',
    'The Pavilion School, Epping Campus',
    'The Ponds High School, The Ponds',
    'The Riverina Anglican College, Wagga Wagga',
    'The Rivers Secondary College, Kadina High Campus',
    'The Rivers Secondary College, Lismore High Campus, Lismore',
    'The Rivers Secondary College, Richmond River High Campus, Lismore',
    'The Rock Central School, The Rock',
    'The Rockhampton Grammar School',
    'The School of Total Education, Warwick',
    'The Scots College',
    'The Scots College Preparatory School, Bellevue Hill',
    'The SCOTS PGC College, Warwick',
    'The Scots School Albury, Albury',
    'The Small School',
    'The Southport School, Southport',
    'The Springfield Anglican College - Primary Campus, Springfield',
    'The Springfield Anglican College, Springfield',
    'The Sycamore School, Alexandra Hills',
    'The Toowoomba Preparatory School',
    'The University High School, Parkville',
    'The Woden School, Deakin',
    'Thebarton Senior College, Torrensville',
    'Theodore State School, Theodore',
    'Thomas Carr College, Tarneit',
    'Thomas Hassall Anglican College, Hoxton Park',
    'Thomas More College, Salisbury Downs',
    'Thomas Reddall High School, Ambarvale',
    'Thomastown Secondary College, Thomastown',
    'Thoona Primary School, Thoona',
    'Thornbury High School, Thornbury',
    'Thorndon Park Primary School, Athelstone',
    'Thornlie Senior High School, Thornlie',
    'Thornton Public School, Thornton',
    'Thuringowa State High School, Thuringowa Central',
    'Ti Tree School, Ti Tree',
    'Timbarra P-9 College, Berwick',
    'Timber Creek School, Katherine',
    'Timboon P-12 School, Timboon',
    'Tin Can Bay P-10 State School, Tin Can Bay',
    'Tintern Grammar, Ringwood East',
    'Tintinara Area School, Tintinara',
    'Tirriwirri School',
    'Tiwi College, Tiwi Islands',
    'Tjuntjuntjara Remote Community School, Kalgoorlie Po',
    'TLK Youth College',
    'Tom Price Senior High School, Tom Price',
    'Tom Quinn Community Centre Alternative School, Bundaberg',
    'Tomaree High School, Salamander Bay',
    'Tombolo Academy',
    'Toodyay District High School, Toodyay',
    'Toogoolawa School, Ormeau',
    'Toogoolawah State High School, Toogoolawah',
    'Tooleybuc Central School, Tooleybuc',
    'Toolooa State High School, South Gladstone',
    'Toongabbie Christian College',
    'Toorak College, Mount Eliza',
    'Toormina High School, Toormina',
    'Toowoomba Anglican School, Toowoomba',
    'Toowoomba Christian College, Highfields',
    'Toowoomba Grammar School, East Toowoomba',
    'Toowoomba State High School, Toowoomba',
    'Top End Group School, Winnellie',
    'Top End School of Flexible Learning, Malak',
    'Toronto High School, Toronto',
    'Torquay Coast Primary School, Torquay',
    'Torrens Valley Christian School, Hope Valley',
    'Tottenham Central School, Tottenham',
    'Townsville Christian College, Vincent',
    'Townsville Community Learning Centre - A State Special School, Mundingburra',
    'Townsville Flexible Learning Centre, West End',
    'Townsville Grammar School, North Ward',
    'Townsville State High School, Townsville',
    'Trafalgar High School, Trafalgar',
    'Tranby College, Baldivis',
    'Trangie Central School, Trangie',
    'Traralgon College, Traralgon - Junior (East) Campus',
    'Traralgon College, Traralgon - Senior (West) Campus',
    'Travancore School, Travancore',
    'Treetops Montessori School, Darlington',
    'Triabunna District School, Triabunna',
    'Trinity Anglican College, Thurgoona',
    'Trinity Anglican School, Earlville',
    'Trinity Bay State High School, Manunda',
    'Trinity Beach State School',
    'Trinity Catholic College, Adamstown',
    'Trinity Catholic College, Auburn',
    'Trinity Catholic College, Goulburn',
    'Trinity Catholic College, Lismore',
    'Trinity Christian School, Wanniassa',
    'Trinity College - Junior School, East Perth',
    'Trinity College Blakeview, Blakeview',
    'Trinity College Colac',
    'Trinity College Gawler River, Angle Vale',
    'Trinity College North, Evanston South',
    'Trinity College Senior, Evanston South',
    'Trinity College South, Evanston South',
    'Trinity College, Beenleigh',
    'Trinity College, East Perth',
    'Trinity College, Gawler',
    'Trinity College, Gladstone',
    'Trinity Grammar School, Kew',
    'Trinity Grammar School, Summer Hill',
    'Trinity Lutheran College, Ashmore',
    'Trinity Lutheran College, Mildura',
    'Truganina P-9 College, Truganina',
    'Trundle Central School, Trundle',
    'Tuggerah Lakes Secondary College The Entrance Campus, Long Jetty',
    'Tuggerah Lakes Secondary College Tumbi Umbi Campus',
    'Tuggerah Lakes Secondary College, Berkeley Vale',
    'Tullamore Central School, Tullamore',
    'Tullawong State High School, Caboolture',
    'Tullibigeal Central School, Tullibigeal',
    'Tully State High School, Tully',
    'Tumbarumba High School, Tumbarumba',
    'Tumby Bay Area School, Tumby Bay',
    'Tumut High School, Tumut',
    'Turramurra High School, South Turramurra',
    'Tweed River High School, Tweed Heads South',
    'Tweed Valley Adventist College, Murwillumbah',
    'Tyndale Christian College Murray Bridge, Murray Bridge',
    'Tyndale Christian School Strathalbyn, Strathalbyn',
    'Tyndale Christian School, Blacktown',
    'Tyndale Christian School, Salisbury East',
    'Tyrrell College, Sea Lake',
    'UC High School Kaleen, Kaleen',
    'Ulladulla High School, Ulladulla',
    'Ulverstone Secondary College, Ulverstone',
    'Umbakumba School, Alyangula',
    'Umina Public School, Umina Beach',
    'Underdale High School, Underdale',
    'Ungarie Central School, Ungarie',
    'Unity College, Caloundra West',
    'Unity College, Murray Bridge',
    'Unity Grammar College, Austral',
    'University of Adelaide College',
    'University of Canberra Senior Secondary College Lake Ginninderra, Belconnen',
    'University Senior College, Adelaide University',
    'Unley High School, Netherby',
    'Upper Coomera State College, Upper Coomera',
    'Upper Yarra Secondary College, Yarra Junction',
    'Upwey High School, Upwey',
    'Uralla Central School, Uralla',
    'Urana Central School, Urana',
    'Urandangi State School, Mount Isa',
    'Urangan State High School, Urangan',
    'Urrbrae Agricultural High School, Netherby',
    'Ursula Frayne Catholic College, Victoria Park',
    'Valkstone Primary School, Bentleigh East',
    'Valley Hope Christian School',
    'Valley View Secondary School, Para Vista',
    'Varsity College, Varsity Lakes',
    'Verity Christian College, Griffith',
    'Vermont Secondary College, Vermont',
    'Vermont South Special School, Vermont South',
    'Verney Road School, Shepparton',
    'Verona School, Fairfield East',
    'Victor Harbor High School, Victor Harbor',
    'Victoria Plantation State School, Victoria Plantation',
    'Victoria Point State High School, Victoria Point West',
    'Victoria University Secondary College, St Albans',
    'Victorian College For The Deaf, Melbourne',
    'Victorian College of the Arts Secondary School, Southbank',
    'Victorian School Of Languages, Thornbury',
    'Victory Christian College, Strathdale',
    'Victory College, Gympie',
    'Victory Lutheran College, Wodonga',
    'Viewbank College, Rosanna',
    'Viewbank Primary School',
    'Village High School, Ryanston',
    'Villanova College, Coorparoo Dc',
    'Vincentia High School, Vincentia',
    'Virtual School Victoria',
    'Wadalba Community School, Wadalba',
    'Wade High School, Griffith',
    'Wadja Wadja High School, Woorabinda',
    'Wagga Wagga Christian College, Wagga Wagga',
    'Wagga Wagga High School, Wagga Wagga',
    'Wagin District High School, Wagin',
    'Wahroonga Adventist School, Wahroonga',
    'Wahroonga Preparatory School',
    'Waikerie High School, Waikerie',
    'Wairoa School, Bondi Beach',
    'Wakefield School, Wakefield',
    'Walcha Central School, Walcha',
    'Walcom Ngarrwa Secondary College',
    'Walford Anglican School for Girls, Unley',
    'Walgett Community College - High School, Walgett',
    'Wallan Secondary College, Wallan',
    'Wallumbilla State School, Wallumbilla',
    'Wambangalang Environmental Education Centre, Dubbo',
    'Wamberal Public School',
    'Wananami Remote Community School, Derby',
    'Wandoan State School P-10, Wandoan',
    'Wangaratta District Specialist School, Wangaratta',
    'Wangaratta High School, Wangaratta',
    'Wangee Park School, Campsie',
    'Wangetti Technical and Vocational Education College, Port Douglas',
    'Wangkatjungka Remote Community School, Fitzroy Crossing',
    'Wanneroo Secondary College, Wanneroo',
    'Wanniassa School, Wanniassa',
    'Wantirna College, Wantirna',
    'Warakirri College, Fairfield',
    'Waranara School',
    'Waratah Special Developmental School, Bellfield',
    'Warialda High School, Warialda',
    'Warilla High School',
    'Warnbro Community High School Education Support Centre, Warnbro',
    'Warnbro Community High School, Warnbro',
    'Warners Bay High School, Warners Bay',
    'Waroona District High School, Waroona',
    'Warracknabeal Secondary College, Warracknabeal',
    'Warracknabeal Special Developmental School, Warracknabeal',
    'Warragul & District Specialist School, Warragul',
    'Warragul Regional College, Warragul',
    'Warrah Specialist School',
    'Warrandyte High School, Warrandyte',
    'Warrawong High School, Warrawong',
    'Warrawong Intensive English Centre, Warrawong',
    'Warren Central School, Warren',
    'Warriappendi School, Marleston',
    'Warringa Park School, Hoppers Crossing',
    'Warrnambool College, Warrnambool',
    'Warrumbungle National Park Environmental Education Centre, Coonabarabran',
    'Warruwi School, Warruwi',
    'Warwick Christian College - Canningvale Road Campus, Warwick',
    'Warwick Christian College, Warwick',
    'Warwick Senior High School, Warwick',
    'Warwick State High School, Warwick',
    'Wauchope High School, Wauchope',
    'Wavell State High School, Wavell Heights',
    'Waverley Christian College, Vermont',
    'Waverley College, Waverley',
    'WAYS Secondary, Bondi',
    'Wedderburn College, Wedderburn',
    'Wee Waa High School, Wee Waa',
    'Weeroona College Bendigo, Bendigo',
    'Wellington High School, Wellington',
    'Wellington Point State High School, Wellington Point',
    'Wellington Secondary College, Mulgrave',
    'Wenona School, North Sydney',
    'Wentworth Point High School',
    'Werribee Secondary College, Werribee',
    'Werrimull P-12 School, Werrimull',
    'Wesley College, Elsternwick',
    'Wesley College, Glen Waverley',
    'Wesley College, Melbourne',
    'Wesley College, South Perth',
    'West Arnhem College, Jabiru',
    'West Coast Secondary Education Support Centre, Warwick',
    'West Lakes Shore School R-7, West Lakes Shore',
    'West Moreton Anglican College, Ipswich',
    'West Wallsend High School, West Wallsend',
    'West Wyalong High School, West Wyalong',
    'Westall Secondary College, Clayton South',
    'Westbourne College Sydney, Ultimo',
    'Westbourne Grammar School, Werribee',
    'Western Australian College Of Agriculture - Cunderdin, Cunderdin',
    'Western Australian College Of Agriculture - Denmark, Denmark',
    'Western Australian College Of Agriculture - Harvey, Wokalup',
    'Western Australian College Of Agriculture - Morawa, Morawa',
    'Western Australian College Of Agriculture - Narrogin, Narrogin',
    'Western Cape College, Rocky Point',
    'Western College ALESCO Learning Centre, Dubbo',
    'Western English Language School, Braybrook',
    'Western Grammar School, Plumpton',
    'Western Heights Secondary College, Hamlyn Heights',
    'Western Port Secondary College, Hastings',
    'Western Riverina Community School, Griffith',
    'Western Suburbs State Special School, Inala',
    'Westfields Sports High School',
    'Westminster School, Marion',
    'Westside Christian College, Goodna',
    'Wewak Street School, North Albury',
    'Wheelers Hill Secondary College, Wheelers Hill',
    'Whitebridge High School, Whitebridge',
    'Whitefriars College, Donvale',
    'Whitehorse Primary School, Blackburn North',
    'Whites Hill State College, Carina',
    'Whitsunday Anglican School, Beaconsfield',
    'Whitsunday Christian College, Cannonvale',
    'Whittlesea Secondary College, Whittlesea',
    'Whyalla Secondary College',
    'Whyalla Special Education Centre, Whyalla Norrie',
    'Wilcannia Central School, Wilcannia',
    'Wilderness School, Medindie',
    'Wiley Park Girls High School, Punchbowl',
    'Willans Hill School, Wagga Wagga',
    'Willetton Senior High School, Willetton',
    'William Carey Christian School, Prestons',
    'William Clarke College, Kellyville',
    'William Rose School, Seven Hills',
    'William Ross State High School, Aitkenvale',
    'William Ruthven Secondary College, Reservoir',
    'Williamstown High School, Williamstown',
    'Willoughby Girls High School, Willoughby',
    'Willowra Education Centre, Alice Springs',
    'Willowra School, Willowra',
    'Willunga High School, Willunga',
    'Willunga Waldorf School, Willunga',
    'Willyama High School, Broken Hill',
    'Wilson Park School, Lismore',
    'Wilsonton State High School',
    'Wilton Public School',
    'Wiluna Remote Community School, Wiluna',
    'Windaroo State School, Mount Warren Park',
    'Windaroo Valley State High School, Bahrs Scrub',
    'Windsor High School, Mcgraths Hill',
    'Wingham High School, Wingham',
    'Winmalee High School, Winmalee',
    'Winnaleah District High School, Winnaleah',
    'Winton State School, Winton',
    'Wirreanda Secondary School, Morphett Vale',
    'Wisdom College, Calamvale',
    'Wodonga Middle Years College, Wodonga',
    'Wodonga Senior Secondary College, Wodonga',
    'Wollemi College, Werrington',
    'Wollert Secondary College, Wollert',
    'Wollondilly Anglican College, Tahmoor',
    'Wollongong Flexible Learning Centre, Towradgi',
    'Wollongong High School of the Performing Arts, Fairy Meadow',
    'Wolumla Public School',
    'Wondai State School, Wondai',
    'Wongan Hills District High School, Wongan Hills',
    'Wongutha Christian Aboriginal Parent-Directed School, Gibson',
    'Woniora Road School, Hurstville',
    'Woodbridge School, Woodbridge',
    'Woodbury, Baulkham Hills',
    'Woodcrest State College, Springfield',
    'Woodcroft College, Morphett Vale',
    'Woodenbong Central School, Woodenbong',
    'Woodford State School, Woodford',
    'Woodleigh School, Langwarrin South',
    'Woodmans Hill Secondary College, Ballarat East',
    'Woodridge State High School, Logan Central',
    'Woodvale Secondary College, Woodvale',
    'Woodville High School, St Clair',
    'Wooglemai Environmental Education Centre, Oakdale',
    'Woolgoolga High School, Woolgoolga',
    'Woolooware High School, Woolooware',
    'Woombye State School',
    'Woomera Area School, Woomera',
    'Woonona High School, Woonona',
    'Worawa Aboriginal College, Healesville',
    'Woree State High School, Woree',
    'Wudinna Area School, Wudinna',
    'Wugularr Community School, Katherine',
    'Wugularr School, Beswick',
    'Wulerrp Secondary College, Clyde North',
    'Wulungarra Community School, Fitzroy Crossing',
    'Wyalkatchem District High School, Wyalkatchem',
    'Wycheproof P-12 College, Wycheproof',
    'Wycliffe Christian School, Blaxland',
    'Wyndham Central Secondary College, Werribee',
    'Wyndham Christian College',
    'Wyndham College, Quakers Hill',
    'Wyndham District High School, Wyndham',
    'Wynnum State High School, Wynnum',
    'Wynyard High School, Wynyard',
    'Wyong Christian Community School, Wyong',
    'Wyong High School, Wyong',
    'Wyrallah Road Public School, East Lismore',
    'Xavier Catholic College Ballina, Skennars Head',
    'Xavier Catholic College, Bathurst Island',
    'Xavier Catholic College, Hervey Bay',
    'Xavier College Burke Hall, Kew',
    'Xavier College, Gawler',
    'Xavier College, Kew',
    'Xavier College, Llandilo',
    'Xavier Community Education Centre, Winnellie',
    'Xavier High School, North Albury',
    'Y School - (7-9)',
    'Yakanarra Community School, Fitzroy Crossing',
    'Yalata Anangu School, Ceduna',
    'Yanchep Secondary College',
    'Yanco Agricultural High School, Yanco',
    'Yandelora School, Narellan',
    'Yandeyarra Remote Community School, South Hedland',
    'Yanginanook School',
    'Yankalilla Area School, Yankalilla',
    'Yarra Hills Secondary College, Mooroolbark',
    'Yarra Me School, Thomastown',
    'Yarra Ranges Special Developmental School, Mount Evelyn',
    'Yarra Valley Grammar',
    'Yarrabah School, Aspendale',
    'Yarrabah State School, Yarrabah',
    'Yarrabilba State Secondary College',
    'Yarrabing Secondary college',
    'Yarralin School',
    'Yarram Secondary College, Yarram',
    'Yarraman State School, Yarraman',
    'Yarraville Special Developmental School, Yarraville',
    'Yarrawonga College P-12, Yarrawonga',
    'Yass High School, Yass',
    'Yawarra Community School, Dubbo',
    'Yea High School, Yea',
    'Yeoval Central School, Yeoval',
    'Yeppoon State High School, Yeppoon',
    'Yeronga State High School, Yeronga',
    'Yeshivah College',
    'Yesodei Hatorah College, Elwood',
    'Yipirinya School, Alice Springs',
    'Yiramalay Studio School',
    'Yirara College, Alice Springs',
    'Yirrkala Community Education Centre, Nhulunbuy',
    'Yirrkala School, Yirrkala',
    'Yiyili Aboriginal Community School, Halls Creek',
    'YMCA Vocational School, Kingston',
    'Yolla District School, Yolla',
    'York District High School, York',
    'Yorketown Area School, Yorketown',
    'YOS Lawnton, Lawnton',
    'Young High School, Young',
    'Youth Education Centre, Cavan',
    'Youth Futures Community School, Midland',
    'Youth Off The Streets, Blue Haven',
    'Youthinc. Enterprise Academy, Adelaide',
    'Yudi Gunyi School',
    'Yuendumu School, Yuendumu',
    'Yuille Park P-8 Community College',
    'Yulara School, Yulara',
    'Yule Brook College, Maddington',
    'Yulga Jinna Remote Community School, Meekatharra',
  ]),
];
